/*!
 * Wishlist / Favoritter – oprindeligt DressForSuccess (Impulse 7.5),
 * tilpasset Mktæpper (Hyper 1.3.2 fra FoxEcom).
 *
 * - Gæster: favoritter gemmes i browseren (localStorage).
 * - Kunder: favoritter læses fra customer-metafeltet custom.wishlist (via Liquid)
 *   og gemmes tilbage via app proxy'en (settings.wishlist_proxy_path).
 *   Lokale gæste-favoritter flettes ind ved login.
 * - Genbruger temaets produktkort (Section Rendering API), modal-komponent,
 *   knapper og cart drawer. På Hyper: kort = snippets/card-product (via
 *   snippets/wishlist-product-card), kurv-skuffe = event "cart:refresh".
 */
(function () {
  'use strict';

  var configEl = document.getElementById('WishlistConfig');
  if (!configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var S = cfg.strings || {};
  var MAX_ITEMS = 200;
  var GUEST_KEY = 'mk_wishlist';
  var STORE_KEY = cfg.customerId ? GUEST_KEY + '_c' + cfg.customerId : GUEST_KEY;
  var HANDLE_RE = /^[\p{L}\p{N}][\p{L}\p{N}_-]*$/u;
  var LIST_ID_RE = /^[a-z0-9]{4,16}$/;
  var LIST_TYPES = { birthday: '🎂', christmas: '🎄', wish: '🎁', custom: '' };
  var SHARE_TYPES = { birthday: '🎂', christmas: '🎄', wish: '🎁', custom: '', look: '✨' };
  var MAX_LOOKS = 10;
  var MAX_LOOK_ITEMS = 6;
  var MAX_LISTS = 20;
  var MAX_NOTE = 140;
  var NOPOPUP_KEY = 'dfs_wishlist_nopopup';

  /* ------------------------------------------------------------------ */
  /* Hjælpere                                                            */
  /* ------------------------------------------------------------------ */

  var storage = {
    get: function (key) {
      try {
        var raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    set: function (key, value) {
      try {
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (e) { /* privat browsing / fuld storage */ }
    },
    remove: function (key) {
      try {
        window.localStorage.removeItem(key);
      } catch (e) { /* ignore */ }
    }
  };

  function str(key, replacements) {
    var s = S[key] || '';
    if (replacements) {
      Object.keys(replacements).forEach(function (k) {
        s = s.split('[' + k + ']').join(replacements[k]);
      });
    }
    return s;
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, cfg.moneyFormat || (theme.settings && theme.settings.moneyFormat));
    }
    var fox = window.FoxTheme;
    if (fox && fox.Currency && typeof fox.Currency.formatMoney === 'function') {
      return fox.Currency.formatMoney(cents, cfg.moneyFormat || (fox.settings && fox.settings.moneyFormat));
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function isValidHandle(handle) {
    return typeof handle === 'string' && handle.length > 0 && handle.length < 256 && HANDLE_RE.test(handle);
  }

  function toInt(value) {
    var n = parseInt(value, 10);
    return isNaN(n) || n <= 0 ? null : n;
  }

  function countText(n) {
    return n === 1 ? str('countOne') : str('countOther', { count: n });
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  /* ------------------------------------------------------------------ */
  /* Store                                                               */
  /* ------------------------------------------------------------------ */

  function normalizeItems(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (raw) {
      if (!raw) return;
      var item = typeof raw === 'string' ? { handle: raw } : raw;
      var handle = item.handle || item.h;
      if (!isValidHandle(handle) || seen[handle]) return;
      seen[handle] = true;
      var entry = {
        handle: handle,
        id: toInt(item.id),
        variant: toInt(item.variant || item.v),
        added: Number(item.added || item.t) || Date.now(),
        list: typeof item.list === 'string' && LIST_ID_RE.test(item.list) ? item.list : null
      };
      if (typeof item.img === 'string' && item.img.length < 500 && /^(https:)?\/\//.test(item.img)) entry.img = item.img;
      if (typeof item.title === 'string' && item.title) entry.title = item.title.slice(0, 120);
      if (typeof item.note === 'string' && item.note.trim()) entry.note = item.note.trim().slice(0, MAX_NOTE);
      if (item.star === true || item.star === 1 || item.star === 's') entry.star = true;
      // Pris da produktet blev gemt (p0) og senest sete pris – til "faldet i pris" og sortering
      if (toInt(item.p0)) entry.p0 = toInt(item.p0);
      if (toInt(item.price)) entry.price = toInt(item.price);
      out.push(entry);
    });
    return out.slice(0, MAX_ITEMS);
  }

  function normalizeLists(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (raw) {
      if (!raw || !LIST_ID_RE.test(raw.id) || seen[raw.id]) return;
      var name = String(raw.name || '').trim().slice(0, 40);
      if (!name) return;
      seen[raw.id] = true;
      out.push({
        id: raw.id,
        name: name,
        type: Object.prototype.hasOwnProperty.call(LIST_TYPES, raw.type) ? raw.type : 'custom',
        created: Number(raw.created) || Date.now()
      });
    });
    return out.slice(0, MAX_LISTS);
  }

  function normalizeLooks(list) {
    var seen = {};
    var out = [];
    (Array.isArray(list) ? list : []).forEach(function (raw) {
      if (!raw || !LIST_ID_RE.test(raw.id) || seen[raw.id]) return;
      var name = String(raw.name || '').trim().slice(0, 40);
      if (!name) return;
      seen[raw.id] = true;
      var handles = [];
      (Array.isArray(raw.items) ? raw.items : []).forEach(function (h) {
        if (isValidHandle(h) && handles.indexOf(h) === -1) handles.push(h);
      });
      out.push({ id: raw.id, name: name, items: handles.slice(0, MAX_LOOK_ITEMS), created: Number(raw.created) || Date.now() });
    });
    return out.slice(0, MAX_LOOKS);
  }

  function cleanListRefs(state) {
    var ids = {};
    var handles = {};
    state.lists.forEach(function (l) { ids[l.id] = true; });
    state.items.forEach(function (i) {
      handles[i.handle] = true;
      if (i.list && !ids[i.list]) i.list = null;
    });
    // Looks må kun indeholde produkter, der stadig er favoritter
    state.looks = (state.looks || []).map(function (l) {
      l.items = l.items.filter(function (h) { return handles[h]; });
      return l;
    });
    return state;
  }

  function normalizeState(raw) {
    if (!raw) return { items: [], lists: [], looks: [], updated: 0, dirty: false };
    if (Array.isArray(raw)) return { items: normalizeItems(raw), lists: [], looks: [], updated: 0, dirty: false };
    return cleanListRefs({
      items: normalizeItems(raw.items),
      lists: normalizeLists(raw.lists),
      looks: normalizeLooks(raw.looks),
      updated: Number(raw.updated) || 0,
      dirty: !!raw.dirty
    });
  }

  function mergeItems(primary, secondary) {
    var handles = {};
    primary.forEach(function (i) { handles[i.handle] = true; });
    return normalizeItems(primary.concat(secondary.filter(function (i) { return !handles[i.handle]; })));
  }

  function mergeLists(primary, secondary) {
    var ids = {};
    primary.forEach(function (l) { ids[l.id] = true; });
    return normalizeLists(primary.concat(secondary.filter(function (l) { return !ids[l.id]; })));
  }

  function newListId() {
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 6)).slice(-12);
  }

  function listLabel(list) {
    if (!list) return '';
    var emoji = SHARE_TYPES[list.type] || '';
    return (emoji ? emoji + ' ' : '') + list.name;
  }

  var Store = (function () {
    var state = { items: [], lists: [], looks: [], updated: 0, dirty: false };
    var pushTimer = null;
    var pushing = false;

    function persist() {
      storage.set(STORE_KEY, state);
    }

    function changed(action, handle) {
      emit('wishlist:change', { action: action, handle: handle, items: Store.items() });
    }

    function touch(action, handle) {
      state.updated = Date.now();
      if (cfg.customerId) state.dirty = true;
      persist();
      changed(action, handle);
      schedulePush();
    }

    function schedulePush() {
      if (!cfg.customerId || !cfg.proxy) return;
      clearTimeout(pushTimer);
      pushTimer = setTimeout(push, 600);
    }

    function payload() {
      return JSON.stringify({ items: state.items, lists: state.lists, looks: state.looks, updated: state.updated });
    }

    function push() {
      if (!cfg.customerId || !cfg.proxy || pushing) return;
      pushTimer = null;
      pushing = true;
      var sentAt = state.updated;
      fetch(cfg.proxy, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: payload()
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Wishlist sync failed: ' + res.status);
          // Kun "rent", hvis der ikke er sket ændringer imens
          if (state.updated === sentAt) {
            state.dirty = false;
            persist();
          }
        })
        .catch(function (err) {
          // Beholdes som "dirty" og prøves igen ved næste sidevisning/ændring
          if (window.console) console.warn(err);
        })
        .then(function () {
          pushing = false;
          if (state.dirty && state.updated !== sentAt) schedulePush();
        });
    }

    function flushOnLeave() {
      if (!pushTimer || !cfg.proxy || !navigator.sendBeacon) return;
      clearTimeout(pushTimer);
      pushTimer = null;
      try {
        navigator.sendBeacon(cfg.proxy, new Blob([payload()], { type: 'application/json' }));
      } catch (e) { /* ignore */ }
    }

    function init() {
      var local = normalizeState(storage.get(STORE_KEY));

      if (!cfg.customerId) {
        state = local;
        return;
      }

      var server = normalizeState(cfg.server);
      // Nyeste version vinder (lokal kan være nyere, hvis sidste sync ikke nåede igennem)
      state = local.updated > server.updated ? local : { items: server.items, lists: server.lists, looks: server.looks, updated: server.updated, dirty: false };

      // Flet favoritter fra før login ind på kontoen
      var guest = normalizeState(storage.get(GUEST_KEY));
      if (guest.items.length) {
        state.items = mergeItems(state.items, guest.items);
        state.lists = mergeLists(state.lists, guest.lists);
        var lookIds = {};
        state.looks.forEach(function (l) { lookIds[l.id] = true; });
        state.looks = normalizeLooks(state.looks.concat(guest.looks.filter(function (l) { return !lookIds[l.id]; })));
        cleanListRefs(state);
        state.updated = Date.now();
        state.dirty = true;
        storage.remove(GUEST_KEY);
      }

      persist();
      if (state.dirty) schedulePush();
    }

    function reloadFromStorage() {
      state = normalizeState(storage.get(STORE_KEY));
      changed('sync');
    }

    window.addEventListener('storage', function (evt) {
      if (evt.key === STORE_KEY) reloadFromStorage();
    });
    window.addEventListener('pagehide', flushOnLeave);
    window.addEventListener('pageshow', function (evt) {
      if (evt.persisted) reloadFromStorage();
    });

    return {
      init: init,
      items: function () {
        return state.items.map(function (i) { return Object.assign({}, i); });
      },
      count: function () { return state.items.length; },
      has: function (handle) {
        return state.items.some(function (i) { return i.handle === handle; });
      },
      get: function (handle) {
        var found = state.items.filter(function (i) { return i.handle === handle; })[0];
        return found ? Object.assign({}, found) : null;
      },
      add: function (item) {
        if (!item || !isValidHandle(item.handle) || this.has(item.handle)) return;
        state.items = normalizeItems([item].concat(state.items));
        touch('add', item.handle);
      },
      remove: function (handle) {
        if (!this.has(handle)) return;
        state.items = state.items.filter(function (i) { return i.handle !== handle; });
        cleanListRefs(state);
        touch('remove', handle);
      },
      setVariant: function (handle, variantId) {
        var changedAny = false;
        state.items.forEach(function (i) {
          if (i.handle === handle && i.variant !== toInt(variantId)) {
            i.variant = toInt(variantId);
            changedAny = true;
          }
        });
        if (changedAny) touch('variant', handle);
      },
      clear: function () {
        if (!state.items.length) return;
        state.items = [];
        state.looks = [];
        touch('clear');
      },
      /* ---- Looks ---- */
      looks: function () {
        return state.looks.map(function (l) { return Object.assign({}, l, { items: l.items.slice() }); });
      },
      getLook: function (id) {
        var found = state.looks.filter(function (l) { return l.id === id; })[0];
        return found ? Object.assign({}, found, { items: found.items.slice() }) : null;
      },
      createLook: function (name) {
        name = String(name || '').trim().slice(0, 40);
        if (!name || state.looks.length >= MAX_LOOKS) return null;
        var look = { id: newListId(), name: name, items: [], created: Date.now() };
        state.looks.push(look);
        touch('looks');
        return Object.assign({}, look, { items: [] });
      },
      renameLook: function (id, name) {
        name = String(name || '').trim().slice(0, 40);
        if (!name) return;
        var changedAny = false;
        state.looks.forEach(function (l) { if (l.id === id && l.name !== name) { l.name = name; changedAny = true; } });
        if (changedAny) touch('looks');
      },
      deleteLook: function (id) {
        var before = state.looks.length;
        state.looks = state.looks.filter(function (l) { return l.id !== id; });
        if (state.looks.length !== before) touch('looks');
      },
      /** Tilføjer/fjerner et produkt i et look. Returnerer 'added', 'removed' eller 'full'. */
      toggleLookItem: function (id, handle) {
        var result = null;
        state.looks.forEach(function (l) {
          if (l.id !== id) return;
          var at = l.items.indexOf(handle);
          if (at > -1) { l.items.splice(at, 1); result = 'removed'; }
          else if (l.items.length >= MAX_LOOK_ITEMS) { result = 'full'; }
          else if (Store.has(handle)) { l.items.push(handle); result = 'added'; }
        });
        if (result === 'added' || result === 'removed') touch('looks');
        return result;
      },
      /* ---- Lister ---- */
      lists: function () {
        return state.lists.map(function (l) { return Object.assign({}, l); });
      },
      getList: function (id) {
        var found = state.lists.filter(function (l) { return l.id === id; })[0];
        return found ? Object.assign({}, found) : null;
      },
      listCount: function (id) {
        return state.items.filter(function (i) { return i.list === id; }).length;
      },
      createList: function (name, type) {
        name = String(name || '').trim().slice(0, 40);
        if (!name || state.lists.length >= MAX_LISTS) return null;
        var list = { id: newListId(), name: name, type: LIST_TYPES.hasOwnProperty(type) ? type : 'custom', created: Date.now() };
        state.lists.push(list);
        touch('lists');
        return Object.assign({}, list);
      },
      updateList: function (id, name, type) {
        var changedAny = false;
        state.lists.forEach(function (l) {
          if (l.id !== id) return;
          var n = String(name || '').trim().slice(0, 40);
          if (n) l.name = n;
          if (type && LIST_TYPES.hasOwnProperty(type)) l.type = type;
          changedAny = true;
        });
        if (changedAny) touch('lists');
      },
      deleteList: function (id) {
        if (!this.getList(id)) return;
        state.lists = state.lists.filter(function (l) { return l.id !== id; });
        state.items.forEach(function (i) { if (i.list === id) i.list = null; });
        touch('lists');
      },
      setList: function (handle, listId) {
        listId = listId && this.getList(listId) ? listId : null;
        var changedAny = false;
        state.items.forEach(function (i) {
          if (i.handle === handle && i.list !== listId) {
            i.list = listId;
            changedAny = true;
          }
        });
        if (changedAny) touch('list', handle);
      },
      setStar: function (handle, on) {
        var changedAny = false;
        state.items.forEach(function (i) {
          if (i.handle !== handle || !!i.star === !!on) return;
          if (on) i.star = true; else delete i.star;
          changedAny = true;
        });
        if (changedAny) touch('star', handle);
      },
      setNote: function (handle, text) {
        text = String(text || '').replace(/\s+/g, ' ').trim().slice(0, MAX_NOTE);
        var changedAny = false;
        state.items.forEach(function (i) {
          if (i.handle !== handle || (i.note || '') === text) return;
          if (text) i.note = text; else delete i.note;
          changedAny = true;
        });
        if (changedAny) touch('note', handle);
      },
      setMeta: function (handle, meta) {
        var changedAny = false;
        state.items.forEach(function (i) {
          if (i.handle !== handle) return;
          if (meta.img && i.img !== meta.img && /^(https:)?\/\//.test(meta.img) && meta.img.length < 500) { i.img = meta.img; changedAny = true; }
          if (meta.title && !i.title) { i.title = String(meta.title).slice(0, 120); changedAny = true; }
          var price = toInt(meta.price);
          if (price && i.price !== price) { i.price = price; changedAny = true; }
          if (price && !i.p0) { i.p0 = price; changedAny = true; }
        });
        if (changedAny) {
          // Kun visuelle data – gemmes uden at trigge en ny rendering
          persist();
          schedulePush();
        }
      },
      push: push
    };
  })();

  // Initialiseres før wishlist-siden renderes
  Store.init();

  /* ------------------------------------------------------------------ */
  /* Hjerteknapper og header                                             */
  /* ------------------------------------------------------------------ */

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = Store.has(btn.getAttribute('data-product-handle'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? str('remove') : str('add');
      btn.setAttribute('title', label);
      var current = btn.getAttribute('aria-label') || '';
      var productName = current.indexOf(': ') > -1 ? current.slice(current.indexOf(': ') + 2) : '';
      btn.setAttribute('aria-label', productName ? label + ': ' + productName : label);
    });
  }

  function syncHeader(bump) {
    var n = Store.count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      if (bump && n > 0) {
        el.classList.remove('is-bumping');
        void el.offsetWidth;
        el.classList.add('is-bumping');
      }
    });
    document.querySelectorAll('[data-wishlist-header]').forEach(function (el) {
      el.classList.toggle('has-items', n > 0);
    });
  }

  function variantFromSource(btn) {
    var formId = btn.getAttribute('data-variant-source');
    if (!formId) return null;
    var form = document.getElementById(formId);
    var input = form && form.querySelector('[name="id"]');
    return input ? toInt(input.value) : null;
  }

  function pop(btn) {
    btn.classList.remove('is-popping');
    void btn.offsetWidth;
    btn.classList.add('is-popping');
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (!isValidHandle(handle)) return;

    if (Store.has(handle)) {
      if (WishlistPage.handlesRemoval(handle)) {
        WishlistPage.removeWithUndo(handle);
      } else {
        Store.remove(handle);
      }
    } else {
      var meta = productMeta(btn);
      Store.add({
        handle: handle,
        id: toInt(btn.getAttribute('data-product-id')),
        variant: variantFromSource(btn),
        added: Date.now(),
        img: meta.img,
        title: meta.title,
        p0: toInt(btn.getAttribute('data-product-price')),
        price: toInt(btn.getAttribute('data-product-price'))
      });
      pop(btn);
      ListPopup.afterAdd(handle, meta);
    }
  }, true);

  function productMeta(btn) {
    var scope = btn.closest('.grid-product, .product-card') || btn.closest('[id^="ProductSection-"], [id^="MainProduct-"], product-info, quick-view-modal') || btn.closest('.product-single__meta') || null;
    var titleEl = scope && scope.querySelector('.grid-product__title, .product-card__title, .product-single__title, h1.product__title');
    var imgEl = scope && scope.querySelector('.grid-product__image-mask img, .product-card__image--main img, .product__main-photos img, .product-main-slide img, .product__media img, img');
    var src = imgEl ? (imgEl.currentSrc || '') : '';
    if (!/^(https:)?\/\//.test(src)) src = imgEl ? (imgEl.getAttribute('src') || '') : '';
    if (!/^(https:)?\/\//.test(src)) src = '';
    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      img: src ? src.replace(/([?&])width=\d+/, '$1width=300') : ''
    };
  }

  document.addEventListener('wishlist:change', function (evt) {
    syncButtons();
    syncHeader(evt.detail && evt.detail.action === 'add');
  });

  // "Senest sete" bygges af temaets JS uden Liquid → hjertet tilføjes her
  var heartSvg = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart icon--stroke-scalable wishlist-icon" viewBox="0 0 64 64"><path d="M51.27 15.05a13 13 0 0 0-18.44 0l-.83.83-.83-.83a13 13 0 0 0-18.44 18.44l.83.83L32 52.77l18.44-18.45.83-.83a13 13 0 0 0 0-18.44Z"/></svg>';

  function enhanceJsCards() {
    if (!cfg.cardHearts) return;
    document.querySelectorAll('[data-section-type="recently-viewed"] .grid-product:not([data-wishlist-enhanced]), recently-viewed-products .product-card:not([data-wishlist-enhanced])').forEach(function (card) {
      card.setAttribute('data-wishlist-enhanced', '');
      if (card.querySelector('[data-wishlist-toggle]')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var mask = card.querySelector('.grid-product__image-mask, .product-card__image-wrapper');
      var match = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (!match || !mask) return;
      var handle = decodeURIComponent(match[1]);
      if (!isValidHandle(handle)) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wishlist-btn wishlist-btn--card wishlist-btn--' + (cfg.cardPosition || 'top-left');
      btn.setAttribute('data-wishlist-toggle', '');
      btn.setAttribute('data-product-handle', handle);
      var title = card.querySelector('.grid-product__title, .product-card__title');
      btn.setAttribute('aria-label', str('add') + (title ? ': ' + title.textContent.trim() : ''));
      btn.innerHTML = heartSvg;
      mask.appendChild(btn);
    });
  }

  // Kort der indsættes dynamisk (anbefalinger, quick shop, AJAX-filtre, senest sete …)
  var syncQueued = false;
  new MutationObserver(function (mutations) {
    if (syncQueued) return;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        syncQueued = true;
        window.requestAnimationFrame(function () {
          syncQueued = false;
          enhanceJsCards();
          syncButtons();
          syncHeader();
        });
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ------------------------------------------------------------------ */
  /* Modals (temaets theme.Modals med enkel fallback)                    */
  /* ------------------------------------------------------------------ */

  var modals = {};

  function getModal(id) {
    if (modals[id]) return modals[id];
    var el = document.getElementById(id);
    if (!el) return null;

    if (window.theme && typeof theme.Modals === 'function') {
      modals[id] = new theme.Modals(id, 'wishlist-' + id);
    } else {
      modals[id] = {
        open: function () {
          el.classList.add('modal--is-active');
          document.documentElement.classList.add('modal-open');
        },
        close: function () {
          el.classList.remove('modal--is-active');
          document.documentElement.classList.remove('modal-open');
        }
      };
      el.querySelectorAll('.js-modal-close').forEach(function (b) {
        b.addEventListener('click', function () { modals[id].close(); });
      });
      // Temaer uden theme.Modals (fx Hyper): luk ved klik udenfor og på Escape
      el.addEventListener('click', function (evt) {
        var t = evt.target;
        if (t === el || (t.classList && (t.classList.contains('modal__inner') || t.classList.contains('modal__centered')))) modals[id].close();
      });
      document.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape' && el.classList.contains('modal--is-active')) modals[id].close();
      });
    }
    return modals[id];
  }

  function openModal(id) {
    var m = getModal(id);
    if (m) m.open();
  }

  function closeModal(id) {
    var m = getModal(id);
    if (m) m.close();
  }

  /* ------------------------------------------------------------------ */
  /* Kurv                                                                */
  /* ------------------------------------------------------------------ */

  function postCart(lines) {
    return fetch(cfg.cartAdd || (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: lines })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || str('error'));
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /**
   * Lægger linjer i kurven. Prøver samlet først; fejler det (fx ét udsolgt produkt),
   * lægges linjerne i én ad gangen, så de tilgængelige stadig kommer med.
   */
  function addLinesToCart(lines) {
    return postCart(lines).then(
      function (data) { return { items: data.items || [data], errors: [] }; },
      function (err) {
        if (lines.length < 2) throw err;
        var added = [];
        var errors = [];
        return lines.reduce(function (p, line) {
          return p.then(function () {
            return postCart([line]).then(
              function (data) { added = added.concat(data.items || [data]); },
              function (e) { errors.push(e.message); }
            );
          });
        }, Promise.resolve()).then(function () {
          if (!added.length) throw new Error(errors[0] || str('error'));
          return { items: added, errors: errors };
        });
      }
    );
  }

  function afterCartAdd(result, sourceForm, button) {
    if (cfg.cartType === 'page') {
      window.location = cfg.cartPage;
      return;
    }
    // Hyper (FoxEcom): cart-drawer lytter på "cart:refresh" og henter/åbner selv skuffen
    if (window.FoxTheme && document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result.items[0] } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      return;
    }
    if (window.FoxTheme && !document.querySelector('cart-drawer')) {
      window.location = cfg.cartPage;
      return;
    }
    // Impulse: samme event som temaets egne produktformularer → cart drawer opdateres og åbnes
    var target = sourceForm && document.contains(sourceForm) ? sourceForm : getDispatchForm(result.items[0]);
    target.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: result.items[0], addToCartBtn: button },
      bubbles: true
    }));
  }

  var dispatchForm = null;
  function getDispatchForm(item) {
    if (!dispatchForm) {
      dispatchForm = document.createElement('form');
      dispatchForm.hidden = true;
      dispatchForm.setAttribute('data-wishlist-dispatch', '');
      dispatchForm.innerHTML = '<input type="hidden" name="id" value="">';
      document.body.appendChild(dispatchForm);
    }
    dispatchForm.querySelector('[name="id"]').value = item && (item.variant_id || item.id) ? (item.variant_id || item.id) : '';
    return dispatchForm;
  }

  function setLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('btn--loading', loading);
    button.disabled = loading;
  }

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */

  var toastTimer = null;
  function toast(message, actionLabel, onAction) {
    var el = document.querySelector('[data-wishlist-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'wishlist-toast';
      el.setAttribute('data-wishlist-toast', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.hidden = true;
      el.innerHTML = '<span data-wishlist-toast-text></span><button type="button" class="wishlist-toast__action text-link" data-wishlist-toast-action hidden></button>';
      document.body.appendChild(el);
    }
    var text = el.querySelector('[data-wishlist-toast-text]');
    var action = el.querySelector('[data-wishlist-toast-action]');
    text.textContent = message;
    action.hidden = !actionLabel;
    action.textContent = actionLabel || '';
    action.onclick = actionLabel ? function () {
      hide();
      onAction();
    } : null;

    el.hidden = false;
    window.requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hide, actionLabel ? 6000 : 3500);

    function hide() {
      clearTimeout(toastTimer);
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (!el.classList.contains('is-visible')) el.hidden = true;
      }, 300);
    }
  }


  /* ------------------------------------------------------------------ */
  /* Liste-popup: "Læg den på en liste?" + opret/omdøb/slet liste        */
  /* ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------ */
  /* Delte lister for gæster (korte links via serveren)                  */
  /* ------------------------------------------------------------------ */

  var GSHARE_KEY = 'dfs_wishlist_gshares';

  function getBrowserId() {
    var key = 'dfs_wishlist_by';
    var id = '';
    try { id = localStorage.getItem(key) || ''; } catch (e) { /* ignore */ }
    if (!/^[a-z0-9]{8,24}$/.test(id)) {
      id = '';
      while (id.length < 16) id += Math.random().toString(36).slice(2);
      id = id.slice(0, 16);
      try { localStorage.setItem(key, id); } catch (e) { /* ignore */ }
    }
    return id;
  }

  function readGuestShares() {
    try { return JSON.parse(localStorage.getItem(GSHARE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }

  function writeGuestShares(map) {
    try { localStorage.setItem(GSHARE_KEY, JSON.stringify(map)); } catch (e) { /* ignore */ }
  }

  function guestSharePayload(listKey) {
    var list = listKey ? Store.getList(listKey) : null;
    if (listKey && !list) return null; // listen er slettet
    return {
      list: list ? { name: list.name, type: list.type } : null,
      items: Store.items()
        .filter(function (i) { return !listKey || i.list === listKey; })
        .sort(function (a, b) { return (b.star ? 1 : 0) - (a.star ? 1 : 0) || b.added - a.added; })
        .map(function (i) { return { handle: i.handle, variant: i.variant, star: i.star, note: i.note, img: i.img }; })
    };
  }

  function guestShareCreate(listKey) {
    if (!cfg.shareProxy || cfg.customerId) return Promise.resolve(null);
    var map = readGuestShares();
    if (map[listKey] && map[listKey].code) {
      guestShareSync(listKey);
      return Promise.resolve(map[listKey].code);
    }
    var payload = guestSharePayload(listKey);
    if (!payload) return Promise.resolve(null);
    payload.by = getBrowserId();
    return fetch(cfg.shareProxy.replace(/\/$/, '') + '/gshare', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (res) {
      if (!res || !res.code || !res.key) return null;
      var m = readGuestShares();
      m[listKey] = { code: res.code, key: res.key };
      writeGuestShares(m);
      return res.code;
    }).catch(function () { return null; });
  }

  function guestShareSync(onlyKey) {
    if (!cfg.shareProxy || cfg.customerId) return;
    var map = readGuestShares();
    Object.keys(map).forEach(function (listKey) {
      if (onlyKey !== undefined && listKey !== onlyKey) return;
      var entry = map[listKey];
      if (!entry || !entry.code || !entry.key) return;
      var payload = guestSharePayload(listKey) || { gone: true };
      payload.key = entry.key;
      fetch(cfg.shareProxy.replace(/\/$/, '') + '/gshare/' + entry.code, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (payload.gone || r.status === 404 || r.status === 403) {
          var m = readGuestShares();
          delete m[listKey];
          writeGuestShares(m);
        }
      }).catch(function () { /* prøver igen ved næste ændring */ });
    });
  }

  // Gæsters delte lister holdes opdateret, når de ændrer favoritter (også fra andre sider)
  var guestSyncTimer = null;
  document.addEventListener('wishlist:change', function () {
    if (!cfg.shareProxy || cfg.customerId) return;
    if (!Object.keys(readGuestShares()).length) return;
    clearTimeout(guestSyncTimer);
    guestSyncTimer = setTimeout(function () { guestShareSync(); }, 1200);
  });

  var ListPopup = (function () {
    var enabled = !!cfg.lists;
    var root = null;
    var state = null; // { mode, handle, meta, listId, onDone }
    var lastFocus = null;

    var TYPE_CHIPS = [
      { type: 'birthday', label: str('typeBirthday') },
      { type: 'christmas', label: str('typeChristmas') },
      { type: 'wish', label: str('typeWish') },
      { type: 'custom', label: str('typeCustom') }
    ];

    function build() {
      if (root) return root;
      root = document.createElement('div');
      root.className = 'wl-pop';
      root.hidden = true;
      root.innerHTML =
        '<div class="wl-pop__backdrop" data-wl-close></div>' +
        '<div class="wl-pop__panel" role="dialog" aria-modal="true" aria-labelledby="WlPopTitle" tabindex="-1">' +
          '<button type="button" class="wl-pop__close" data-wl-close aria-label="' + escapeHtml(str('close')) + '">' +
            '<svg aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
          '</button>' +
          '<div class="wl-pop__product" data-wl-product></div>' +
          '<h2 class="wl-pop__title" id="WlPopTitle" data-wl-title></h2>' +
          '<p class="wl-pop__sub" data-wl-sub></p>' +
          '<div class="wl-pop__lists" data-wl-lists role="list"></div>' +
          '<button type="button" class="wl-pop__new" data-wl-new><span class="wl-pop__plus" aria-hidden="true">+</span>' + escapeHtml(str('newList')) + '</button>' +
          '<form class="wl-pop__create" data-wl-create hidden novalidate>' +
            '<p class="wl-pop__label">' + escapeHtml(str('listPurpose')) + '</p>' +
            '<div class="wl-pop__chips" role="radiogroup">' +
              TYPE_CHIPS.map(function (c) {
                return '<button type="button" class="wl-pop__chip" role="radio" aria-checked="false" data-wl-type="' + c.type + '">' + escapeHtml(c.label) + '</button>';
              }).join('') +
            '</div>' +
            '<label class="wl-pop__label text-label" for="WlPopName">' + escapeHtml(str('listName')) + '</label>' +
            '<input type="text" id="WlPopName" class="wl-pop__input" maxlength="40" autocomplete="off" data-wl-name placeholder="' + escapeHtml(str('listNamePlaceholder')) + '">' +
            '<button type="submit" class="btn btn--primary btn--full wl-pop__submit" data-wl-submit></button>' +
          '</form>' +
          '<div class="wl-pop__confirm" data-wl-confirm hidden>' +
            '<div class="wl-pop__actions">' +
              '<button type="button" class="btn btn--secondary" data-wl-close>' + escapeHtml(str('cancel')) + '</button>' +
              '<button type="button" class="btn btn--primary" data-wl-confirm-yes>' + escapeHtml(str('deleteList')) + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="wl-pop__footer" data-wl-footer>' +
            '<button type="button" class="btn btn--secondary btn--full" data-wl-skip>' + escapeHtml(str('justSave')) + '</button>' +
            '<label class="wl-pop__optout text-label"><input type="checkbox" data-wl-optout> ' + escapeHtml(str('dontAsk')) + '</label>' +
          '</div>' +
        '</div>';
      document.body.appendChild(root);

      root.addEventListener('click', onClick);
      root.querySelector('[data-wl-create]').addEventListener('submit', onSubmit);
      root.addEventListener('keydown', function (evt) {
        if (evt.key === 'Escape') close();
        if (evt.key === 'Tab') trapTab(evt);
      });
      return root;
    }

    function trapTab(evt) {
      var focusables = Array.prototype.filter.call(
        root.querySelectorAll('button, input, [tabindex="0"]'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
      else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
    }

    function q(sel) { return root.querySelector(sel); }

    function renderProduct() {
      var box = q('[data-wl-product]');
      var meta = state.meta || {};
      if (state.mode !== 'add' && state.mode !== 'move') { box.hidden = true; return; }
      box.hidden = false;
      box.innerHTML =
        (meta.img ? '<img src="' + escapeHtml(meta.img) + '" alt="" width="56" height="74" loading="lazy">' : '<span class="wl-pop__ph" aria-hidden="true"></span>') +
        '<div>' +
          (state.mode === 'add' ? '<p class="wl-pop__saved"><span aria-hidden="true">✓</span> ' + escapeHtml(str('savedToFavorites')) + '</p>' : '') +
          (meta.title ? '<p class="wl-pop__ptitle">' + escapeHtml(meta.title) + '</p>' : '') +
        '</div>';
    }

    function renderLists() {
      var box = q('[data-wl-lists]');
      var current = state.handle ? (Store.get(state.handle) || {}).list : null;
      var lists = Store.lists();
      var rows = [];
      if (state.mode === 'move') {
        rows.push(row(null, str('noList'), Store.count(), current === null, true));
      }
      lists.forEach(function (l) {
        rows.push(row(l.id, listLabel(l), Store.listCount(l.id), current === l.id));
      });
      box.innerHTML = rows.join('');
      box.hidden = !rows.length;
    }

    function row(id, label, count, active, isAll) {
      return '<button type="button" role="listitem" class="wl-pop__row' + (active ? ' is-active' : '') + '" data-wl-pick="' + (id || '') + '">' +
        '<span class="wl-pop__rowname">' + escapeHtml(label) + '</span>' +
        '<span class="wl-pop__rowcount">' + (isAll ? '' : escapeHtml(countText(count))) + '</span>' +
        '<span class="wl-pop__check" aria-hidden="true">' + (active ? '✓' : '') + '</span>' +
      '</button>';
    }

    function setType(type) {
      root.querySelectorAll('[data-wl-type]').forEach(function (chip) {
        var on = chip.getAttribute('data-wl-type') === type;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      state.type = type;
      var input = q('[data-wl-name]');
      var defaults = { birthday: str('defaultBirthday'), christmas: str('defaultChristmas'), wish: str('defaultWish') };
      // Forslag til navn, hvis feltet er tomt eller stadig indeholder et tidligere forslag
      if (!input.value || input.getAttribute('data-suggested') === 'true') {
        input.value = defaults[type] || '';
        input.setAttribute('data-suggested', defaults[type] ? 'true' : 'false');
      }
    }

    function showCreate(show, focus) {
      q('[data-wl-create]').hidden = !show;
      q('[data-wl-new]').hidden = show || state.mode === 'create' || state.mode === 'rename' || state.mode === 'confirm' || Store.lists().length >= MAX_LISTS;
      if (show && focus) setTimeout(function () { q('[data-wl-name]').focus(); }, 50);
    }

    function open(next) {
      if (!enabled) return;
      build();
      state = next;
      lastFocus = document.activeElement;

      var titles = {
        add: str('addToListTitle'),
        move: str('moveTitle'),
        create: str('newList'),
        rename: str('renameTitle'),
        confirm: str('deleteTitle')
      };
      q('[data-wl-title]').textContent = titles[state.mode];
      var sub = q('[data-wl-sub]');
      sub.textContent = state.mode === 'add' ? str('addToListSub')
        : state.mode === 'confirm' ? str('deleteText', { name: listLabel(Store.getList(state.listId)) })
        : '';
      sub.hidden = !sub.textContent;

      renderProduct();
      var showLists = state.mode === 'add' || state.mode === 'move';
      if (showLists) renderLists(); else q('[data-wl-lists]').hidden = true;

      var input = q('[data-wl-name]');
      input.value = '';
      input.setAttribute('data-suggested', 'false');
      if (state.mode === 'rename') {
        var list = Store.getList(state.listId);
        input.value = list ? list.name : '';
        setType(list ? list.type : 'custom');
      } else {
        setType(state.type || null);
      }
      q('[data-wl-submit]').textContent = state.mode === 'rename' ? str('saveChanges')
        : (state.mode === 'create' ? str('createList') : str('createAndSave'));

      var hasLists = Store.lists().length > 0;
      // Har kunden ingen lister endnu, vises opret-formularen direkte
      showCreate(state.mode === 'create' || state.mode === 'rename' || (showLists && !hasLists), false);
      q('[data-wl-confirm]').hidden = state.mode !== 'confirm';
      q('[data-wl-footer]').hidden = state.mode !== 'add';
      q('[data-wl-optout]').checked = false;

      root.hidden = false;
      root.classList.toggle('wl-pop--compact', state.mode === 'confirm');
      document.documentElement.classList.add('wl-pop-open');
      requestAnimationFrame(function () {
        root.classList.add('is-open');
        var target = state.mode === 'create' || state.mode === 'rename' ? q('[data-wl-name]') : q('.wl-pop__panel');
        target.focus();
      });
    }

    function close() {
      if (!root || root.hidden) return;
      if (state && state.mode === 'add' && q('[data-wl-optout]').checked) storage.set(NOPOPUP_KEY, true);
      root.classList.remove('is-open');
      document.documentElement.classList.remove('wl-pop-open');
      setTimeout(function () { root.hidden = true; }, 200);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus(); } catch (e) { /* ignore */ }
      }
      state = null;
    }

    function done(message) {
      var cb = state && state.onDone;
      close();
      if (message) toast(message);
      if (cb) cb();
    }

    function onClick(evt) {
      var t = evt.target;
      if (t.closest('[data-wl-close]')) { close(); return; }
      if (t.closest('[data-wl-skip]')) { close(); return; }
      if (t.closest('[data-wl-new]')) { showCreate(true, true); return; }
      var chip = t.closest('[data-wl-type]');
      if (chip) {
        var input = q('[data-wl-name]');
        if (input.getAttribute('data-suggested') !== 'true' && input.value) input.setAttribute('data-suggested', 'false');
        setType(chip.getAttribute('data-wl-type'));
        input.focus();
        return;
      }
      var pick = t.closest('[data-wl-pick]');
      if (pick) {
        var id = pick.getAttribute('data-wl-pick') || null;
        Store.setList(state.handle, id);
        done(id ? str('savedToList', { name: listLabel(Store.getList(id)) }) : str('removedFromList'));
        return;
      }
      if (t.closest('[data-wl-confirm-yes]')) {
        Store.deleteList(state.listId);
        done(str('listDeleted'));
      }
    }

    function onSubmit(evt) {
      evt.preventDefault();
      var input = q('[data-wl-name]');
      var name = input.value.trim();
      if (!name) {
        input.classList.add('is-invalid');
        input.focus();
        return;
      }
      input.classList.remove('is-invalid');
      if (state.mode === 'rename') {
        Store.updateList(state.listId, name, state.type);
        done(str('listSaved'));
        return;
      }
      var list = Store.createList(name, state.type || 'custom');
      if (!list) return;
      if (state.handle) {
        Store.setList(state.handle, list.id);
        done(str('savedToList', { name: listLabel(list) }));
      } else {
        var cb = state.onCreated;
        done(str('listCreated', { name: listLabel(list) }));
        if (cb) cb(list);
      }
    }

    return {
      enabled: enabled,
      afterAdd: function (handle, meta) {
        if (!enabled || !cfg.listPopup || storage.get(NOPOPUP_KEY)) return;
        open({ mode: 'add', handle: handle, meta: meta });
      },
      move: function (handle, meta, onDone) { open({ mode: 'move', handle: handle, meta: meta, onDone: onDone }); },
      create: function (type, onCreated) { open({ mode: 'create', type: type, onCreated: onCreated }); },
      rename: function (listId) { open({ mode: 'rename', listId: listId }); },
      confirmDelete: function (listId) { open({ mode: 'confirm', listId: listId }); },
      close: close
    };
  })();

  /* ------------------------------------------------------------------ */
  /* Wishlist-side                                                       */
  /* ------------------------------------------------------------------ */

  var WishlistPage = (function () {
    var root = document.querySelector('[data-wishlist-page]');
    var api = {
      handlesRemoval: function () { return false; },
      removeWithUndo: function (handle) { Store.remove(handle); }
    };
    if (!root) return api;

    var els = {
      heading: root.querySelector('[data-wishlist-heading]'),
      countText: root.querySelector('[data-wishlist-count-text]'),
      login: root.querySelector('[data-wishlist-login]'),
      shared: root.querySelector('[data-wishlist-shared-banner]'),
      toolbar: root.querySelector('[data-wishlist-toolbar]'),
      loading: root.querySelector('[data-wishlist-loading]'),
      grid: root.querySelector('[data-wishlist-grid]'),
      more: root.querySelector('[data-wishlist-more]'),
      empty: root.querySelector('[data-wishlist-empty]'),
      boards: root.querySelector('[data-wishlist-boards]'),
      listTitle: root.querySelector('[data-wishlist-list-title]'),
      listEmpty: root.querySelector('[data-wishlist-list-empty]'),
      gift: root.querySelector('[data-wishlist-gift]'),
      share: root.querySelector('[data-wishlist-share]'),
      sharedIntro: root.querySelector('[data-wishlist-shared-intro]'),
      shareHero: root.querySelector('[data-wishlist-share-hero]'),
      shareSteps: root.querySelector('[data-wishlist-share-steps]'),
      shareCta: root.querySelector('[data-wishlist-share-cta]'),
      head: root.querySelector('.wl-head'),
      insights: root.querySelector('[data-wishlist-insights]'),
      collage: root.querySelector('[data-wishlist-collage]'),
      heroActions: root.querySelector('.wl-hero__actions'),
      filterbar: root.querySelector('[data-wishlist-filterbar]'),
      sort: root.querySelector('[data-wishlist-sort]'),
      recs: root.querySelector('[data-wishlist-recs]'),
      recsGrid: root.querySelector('[data-wishlist-recs-grid]'),
      sticky: root.querySelector('[data-wishlist-sticky]'),
      stickyText: root.querySelector('[data-wishlist-sticky-text]'),
      stickyThumbs: root.querySelector('[data-wishlist-sticky-thumbs]')
    };
    var featureOn = false; // Alle billeder er lige store
    var sortMode = 'newest';
    var dataByHandle = {};  // handle -> produktdata fra kortet (pris, lager, tilbud)
    var heroInView = true;
    var listsOn = !!cfg.lists && !!els.boards;

    var pageSize = toInt(root.getAttribute('data-page-size')) || 24;
    // Kort link (?del=kode) → listen hentes fra serveren, så den altid er opdateret
    var delCode = cfg.shareProxy ? (new URLSearchParams(window.location.search).get('del') || '').toLowerCase() : '';
    if (!/^([a-z0-9]{1,14}-[a-z0-9]{8}|g-[a-z0-9]{10})$/.test(delCode)) delCode = '';
    var shareInfo = null;          // svar fra serveren for delCode
    var reservedSet = {};          // handle -> true (reserveret af en anden)
    var mineSet = {};              // handle -> true (reserveret af denne browser)
    var sharedItems = delCode ? [] : parseShared();
    var mode = sharedItems ? 'shared' : 'own';
    var queue = [];      // items der skal vises (i rækkefølge)
    var cursor = 0;      // hvor langt vi er nået i queue
    var cards = {};      // handle -> grid item element
    var cardCache = {};  // handle -> Promise<{el}|{missing}>  (genbruges ved skift mellem lister)
    var renderToken = 0;
    var suppressChange = false;
    var sharedMeta = parseSharedMeta();
    var selectedList = mode === 'own' ? listFromHash() : null;

    function listFromHash() {
      var m = window.location.hash.match(/liste=([a-z0-9]{4,16})/);
      return m && Store.getList(m[1]) ? m[1] : null;
    }

    function parseSharedMeta() {
      var params = new URLSearchParams(window.location.search);
      var name = (params.get('liste') || '').trim().slice(0, 40);
      var type = params.get('type');
      return name ? { name: name, type: SHARE_TYPES.hasOwnProperty(type) ? type : 'custom' } : null;
    }

    function selectList(id) {
      selectedList = id && Store.getList(id) ? id : null;
      var url = window.location.pathname + window.location.search + (selectedList ? '#liste=' + selectedList : '');
      try { history.replaceState(null, '', url); } catch (e) { /* ignore */ }
      render();
    }

    function parseShared() {
      // Læses rå (uden URLSearchParams), så kommaer i noter (%2C) ikke splitter elementerne
      var match = window.location.search.match(/[?&]favoritter=([^&#]*)/);
      if (!match) return null;
      var raw = match[1].replace(/\+/g, '%20');
      return normalizeItems(raw.split(',').map(function (part) {
        var noteAt = part.indexOf('~');
        var note = '';
        if (noteAt > -1) {
          try { note = decodeURIComponent(part.slice(noteAt + 1)); } catch (e) { note = ''; }
          part = part.slice(0, noteAt);
        }
        var bits = part.split(':');
        var handle = '';
        try { handle = decodeURIComponent(bits[0] || '').trim(); } catch (e) { handle = ''; }
        return { handle: handle, variant: bits[1], star: bits[2] === 's', note: note };
      }));
    }

    function currentItems() {
      if (mode === 'shared') {
        // Topønsker først – ellers den rækkefølge, ønskeren delte i
        return sharedItems.map(function (i, n) { return { i: i, n: n }; })
          .sort(function (a, b) { return (b.i.star ? 1 : 0) - (a.i.star ? 1 : 0) || a.n - b.n; })
          .map(function (x) { return x.i; });
      }
      var base = function (a, b) { return (b.star ? 1 : 0) - (a.star ? 1 : 0) || b.added - a.added; };
      var items = Store.items().filter(function (i) { return !selectedList || i.list === selectedList; });
      if (sortMode === 'price-asc' || sortMode === 'price-desc') {
        var dir = sortMode === 'price-asc' ? 1 : -1;
        return items.sort(function (a, b) {
          var pa = priceOf(a), pb = priceOf(b);
          if (pa === null || pb === null) return (pa === null) - (pb === null) || base(a, b);
          return (pa - pb) * dir || base(a, b);
        });
      }
      if (sortMode === 'sale') {
        return items.sort(function (a, b) { return dealScore(b) - dealScore(a) || base(a, b); });
      }
      return items.sort(base);
    }

    /* ---- Pris, tilbud og lager (til mærker, sortering og "siden sidst") ---- */

    function cheapestVariant(data) {
      var list = data.variants.filter(function (v) { return v.available; });
      if (!list.length) list = data.variants;
      return list.slice().sort(function (a, b) { return a.price - b.price; })[0] || null;
    }

    function currentPrice(data) {
      var v = cheapestVariant(data);
      return v ? v.price : (data.price || null);
    }

    function saleInfo(data) {
      var v = cheapestVariant(data);
      if (!v || !data.available || !(v.compareAtPrice > v.price)) return 0;
      return Math.round((v.compareAtPrice - v.price) / v.compareAtPrice * 100);
    }

    function lowCount(data) {
      if (!data.available) return 0;
      var total = 0;
      var known = data.variants.filter(function (v) { return v.available; });
      for (var i = 0; i < known.length; i++) {
        if (known[i].inventory === null || known[i].inventory === undefined) return 0;
        total += Math.max(0, known[i].inventory);
      }
      return total > 0 && total <= 3 ? total : 0;
    }

    function dropAmount(item, data) {
      if (!item || !item.p0) return 0;
      var cur = data ? currentPrice(data) : item.price;
      return cur && cur < item.p0 ? item.p0 - cur : 0;
    }

    function priceOf(item) {
      var d = dataByHandle[item.handle];
      return d ? currentPrice(d) : (item.price || null);
    }

    function dealScore(item) {
      var d = dataByHandle[item.handle];
      if (dropAmount(item, d)) return 2;
      return d && saleInfo(d) ? 1 : 0;
    }

    function daysToXmas() {
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var xmas = new Date(now.getFullYear(), 11, 24);
      if (today > xmas) xmas = new Date(now.getFullYear() + 1, 11, 24);
      return Math.round((xmas - today) / 864e5);
    }

    /* ---- Hentning af produktkort via temaets egen product-grid-item ---- */

    function cardUrl(handle) {
      var base = (cfg.root || '/').replace(/\/$/, '');
      return base + '/products/' + encodeURIComponent(handle) + '?section_id=wishlist-item';
    }

    function fetchCard(handle) {
      if (!cardCache[handle]) {
        cardCache[handle] = fetchCardFresh(handle).catch(function (err) {
          delete cardCache[handle];
          throw err;
        });
      }
      return cardCache[handle];
    }

    function fetchCardFresh(handle) {
      return fetch(cardUrl(handle), { credentials: 'same-origin' }).then(function (res) {
        if (res.status === 404) return { missing: true };
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-wishlist-item-render] > .grid__item');
          return el ? { el: document.importNode(el, true) } : { missing: true };
        });
      });
    }

    function fetchInOrder(items, concurrency) {
      var results = new Array(items.length);
      var index = 0;
      function worker() {
        if (index >= items.length) return Promise.resolve();
        var i = index++;
        return fetchCard(items[i].handle)
          .then(function (r) { results[i] = r; }, function () { results[i] = { error: true }; })
          .then(worker);
      }
      var workers = [];
      for (var w = 0; w < Math.min(concurrency, items.length); w++) workers.push(worker());
      return Promise.all(workers).then(function () { return results; });
    }

    /* ---- Kortlogik ---- */

    function cardData(el) {
      if (el._wishlist) return el._wishlist;
      var script = el.querySelector('[data-wishlist-product]');
      var data = null;
      try { data = JSON.parse(script.textContent); } catch (e) { data = null; }
      el._wishlist = data;
      return data;
    }

    function findVariant(data, id) {
      id = toInt(id);
      if (!data || !id) return null;
      return data.variants.filter(function (v) { return v.id === id; })[0] || null;
    }

    function selectedVariant(el) {
      var data = cardData(el);
      if (!data) return null;
      if (!data.hasVariants) {
        return data.variants.filter(function (v) { return v.available; })[0] || data.variants[0] || null;
      }
      var select = el.querySelector('[data-wishlist-variant-select]');
      return select ? findVariant(data, select.value) : null;
    }

    function priceHtml(variant) {
      var html = '';
      if (variant.compareAtPrice > variant.price) {
        html += '<span class="grid-product__price--original">' + formatMoney(variant.compareAtPrice) + '</span> ';
      }
      return html + formatMoney(variant.price);
    }

    function updateCard(el) {
      var data = cardData(el);
      if (!data) return;
      var variant = selectedVariant(el);
      var idInput = el.querySelector('[data-wishlist-variant-id]');
      var stock = el.querySelector('[data-wishlist-stock]');
      var button = el.querySelector('[data-wishlist-add]');
      var select = el.querySelector('[data-wishlist-variant-select]');
      var error = el.querySelector('[data-wishlist-error]');

      if (idInput) idInput.value = variant ? variant.id : '';
      if (select) select.classList.remove('is-invalid');
      if (error) error.hidden = true;

      // Lagerstatus
      var state = '';
      if (!data.available || (variant && !variant.available)) {
        state = 'out';
      } else if (variant) {
        state = variant.inventory !== null && variant.inventory <= 3 ? 'low' : 'in';
      }
      if (stock) {
        stock.setAttribute('data-state', state);
        stock.textContent = state === 'out' ? str('soldOut') : state === 'low' ? str('lowStock') : state === 'in' ? str('inStock') : '';
      }

      // Pris for valgt variant
      if (variant && data.hasVariants) {
        var priceEl = el.querySelector('.grid-product__price, .product-card .f-price__regular');
        if (priceEl) priceEl.innerHTML = priceHtml(variant);
      }

      // Knap
      if (button) {
        var soldOut = !data.available || (variant && !variant.available);
        button.disabled = !!soldOut;
        var label = button.querySelector('span') || button;
        label.textContent = soldOut ? str('soldOut') : str('addToCart');
      }
      syncQuick(el, data, variant);
    }

    /* ---- Hurtig "Læg i kurv" på billedet (egen visning) ---- */

    function buildQuick(el, data) {
      var host = el.querySelector('[data-wishlist-card]');
      if (!host || host.querySelector('.wl-quick')) return;
      var q = document.createElement('div');
      q.className = 'wl-quick wl-quick--below';
      q.innerHTML = '<div class="wl-quick__row"><button type="button" class="wl-quick__add" data-wl-quick-add>' + escapeHtml(str('quickAdd')) + '</button></div>';
      // Lige under prisen – før liste-pillen og noten
      host.insertBefore(q, host.firstChild);
      el.classList.add('wl-has-quick');

      // Variantvalget flyttes op ved siden af "Læg i kurv"
      var wrap = el.querySelector('.wishlist-card__select-wrap');
      var select = wrap && wrap.querySelector('[data-wishlist-variant-select]');
      if (wrap && select) {
        var label = el.querySelector('label[for="' + select.id + '"]');
        var row = q.querySelector('.wl-quick__row');
        if (label) row.appendChild(label);
        row.insertBefore(wrap, row.firstChild);
        wrap.classList.add('wl-quick__select');
        // Synlig tekst i lille skrift – selve select'en ligger usynligt ovenpå i 16 px,
        // så iPhone ikke zoomer ind, når man trykker
        var shown = document.createElement('span');
        shown.className = 'wl-quick__value';
        shown.setAttribute('aria-hidden', 'true');
        wrap.appendChild(shown);
        var first = select.options[0];
        var label = shortVariantLabels(data);
        if (first && !first.value) first.textContent = label.placeholder;
        // Kun det, der varierer (fx "XS" i stedet for "XS / Chokoladebrun")
        Array.prototype.forEach.call(select.options, function (o) {
          if (!o.value || !label.byId[o.value]) return;
          var soldOut = o.textContent.match(/\s+–\s.*$/);
          o.textContent = label.byId[o.value] + (soldOut ? soldOut[0] : '');
        });
        el.classList.add('wl-has-select');
      } else if (data.hasVariants === false) {
        // Produkter uden størrelser: "Onesize", så knapperne flugter på tværs af kortene
        var one = document.createElement('span');
        one.className = 'wl-quick__select wl-quick__select--static';
        one.innerHTML = '<span class="wl-quick__value">' + escapeHtml(str('oneSize')) + '</span>';
        q.querySelector('.wl-quick__row').insertBefore(one, q.querySelector('.wl-quick__row').firstChild);
      }
    }

    var SIZE_RE = /st(ø|o)rr|size|str/i;

    function shortVariantLabels(data) {
      var names = data.optionNames || [];
      var vary = names.map(function (n, i) {
        var seen = {};
        data.variants.forEach(function (v) { seen[(v.options || [])[i]] = true; });
        return Object.keys(seen).length > 1;
      });
      var idx = [];
      vary.forEach(function (on, i) { if (on) idx.push(i); });
      if (!idx.length) idx = names.map(function (n, i) { return i; });
      var byId = {};
      data.variants.forEach(function (v) {
        var opts = v.options || [];
        byId[v.id] = opts.length ? idx.map(function (i) { return opts[i]; }).filter(Boolean).join(' / ') : v.title;
      });
      var main = idx.length === 1 ? names[idx[0]] : '';
      var isSize = idx.length === 1 ? SIZE_RE.test(main || '') : idx.some(function (i) { return SIZE_RE.test(names[i] || ''); });
      return {
        byId: byId,
        isSize: isSize,
        placeholder: isSize || !main ? str('quickSize') : main
      };
    }

    function syncQuick(el, data, variant) {
      var q = el.querySelector('.wl-quick');
      if (!q) return;
      var select = el.querySelector('[data-wishlist-variant-select]');
      var current = select ? select.value : '';
      if (select) select.classList.toggle('has-value', !!current);
      var shownEl = q.querySelector('.wl-quick__value');
      if (shownEl && select) {
        var opt = select.options[select.selectedIndex];
        var txt = opt ? opt.textContent.replace(/\s+–.*$/, '').trim() : '';
        // "Str. XS" når det er en størrelse
        if (current && shortVariantLabels(data).isSize && txt.indexOf('/') === -1) txt = str('quickSize') + ' ' + txt;
        shownEl.textContent = txt;
        shownEl.parentNode.classList.toggle('has-value', !!current);
        shownEl.parentNode.classList.toggle('is-invalid', select.classList.contains('is-invalid'));
      }
      q.querySelectorAll('[data-wl-size]').forEach(function (b) {
        var on = b.getAttribute('data-wl-size') === current;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on);
      });
      var add = q.querySelector('[data-wl-quick-add]');
      var soldOut = !data.available || (variant && !variant.available);
      add.disabled = !!soldOut;
      add.textContent = soldOut ? str('soldOut') : str('quickAdd');
    }

    function renderFlag(el, data) {
      if (mode !== 'own') return;
      var mask = el.querySelector('.grid-product__image-mask, .product-card__image-wrapper');
      if (!mask) return;
      var old = mask.querySelector('.wl-flag');
      if (old) old.parentNode.removeChild(old);
      var item = Store.get(data.handle);
      var drop = dropAmount(item, data);
      var low = lowCount(data);
      var sale = saleInfo(data);
      var cls = '', text = '';
      if (drop) { cls = 'drop'; text = str('flagDrop', { amount: formatMoney(drop) }); }
      else if (low) { cls = 'low'; text = str('flagLow', { count: low }); }
      else if (sale) { cls = 'drop'; text = '↓ ' + sale + ' %'; }
      if (!text) return;
      var f = document.createElement('span');
      f.className = 'wl-flag wl-flag--' + cls;
      f.textContent = text;
      mask.appendChild(f);
    }

    /* ---- Første favorit stort ---- */

    function applyFeature() {
      var items = Array.prototype.filter.call(els.grid.children, function (c) { return c.hasAttribute('data-wishlist-handle') && !c.classList.contains('is-removing'); });
      items.forEach(function (c) { c.classList.remove('wl-feature'); });
      var on = featureOn && mode === 'own' && items.length >= 5;
      if (on) items[0].classList.add('wl-feature');
      root.classList.toggle('has-feature', on);
    }

    /* ---- Hero: "siden sidst", collage og bar i bunden ---- */

    function chip(key, n, cls, action) {
      var text = escapeHtml(str(key, { count: '\u00a7' })).replace('\u00a7', '<b>' + n + '</b>');
      var icon = { insightDrop: '💸', insightSale: '🏷️', insightLow: '⏳', insightXmas: '🎄' }[key] || '';
      var inner = '<span aria-hidden="true">' + icon + '</span> ' + text;
      return '<li>' + (action
        ? '<button type="button" class="wl-insight' + (cls ? ' ' + cls : '') + '" data-wl-insight="' + action + '">' + inner + '</button>'
        : '<span class="wl-insight' + (cls ? ' ' + cls : '') + '">' + inner + '</span>') + '</li>';
    }

    function updateHero(hasItems) {
      var own = mode === 'own' && hasItems;
      root.classList.toggle('has-hero', own);
      if (els.collage) {
        var imgs = own ? currentItems().concat(Store.items()).filter(function (i) { return i.img; }) : [];
        var seen = {};
        imgs = imgs.filter(function (i) { if (seen[i.img]) return false; seen[i.img] = true; return true; }).slice(0, 3);
        els.collage.hidden = !imgs.length;
        els.collage.className = 'wl-hero__collage is-' + imgs.length;
        els.collage.innerHTML = imgs.map(function (i) { return '<i style="background-image:url(\'' + escapeHtml(i.img) + '\')"></i>'; }).join('') +
          (imgs.length ? '<span class="wl-hero__heart">' + HEART_SVG + '</span><span class="wl-hero__spark wl-hero__spark--a">✨</span><span class="wl-hero__spark wl-hero__spark--b">✨</span>' : '');
      }
      if (!els.insights) return;
      if (!own) { els.insights.hidden = true; return; }
      var drop = 0, sale = 0, low = 0;
      Store.items().forEach(function (item) {
        var d = dataByHandle[item.handle];
        if (dropAmount(item, d)) drop++;
        else if (d && saleInfo(d)) sale++;
        if (d && lowCount(d)) low++;
      });
      var html = '';
      if (drop) html += chip('insightDrop', drop, 'is-hot', 'sale');
      if (sale) html += chip('insightSale', sale, drop ? '' : 'is-hot', 'sale');
      if (low) html += chip('insightLow', low, '', '');
      var xmasList = listsOn ? Store.lists().filter(function (l) { return l.type === 'christmas'; })[0] : null;
      var days = daysToXmas();
      var month = new Date().getMonth();
      if (xmasList || month >= 10) {
        var label = days === 0 ? str('insightXmasToday') : days === 1 ? str('insightXmasOne') : null;
        html += label
          ? '<li><span class="wl-insight"><span aria-hidden="true">🎄</span> ' + escapeHtml(label) + '</span></li>'
          : chip('insightXmas', days, '', xmasList ? 'list:' + xmasList.id : '');
      }
      els.insights.hidden = !html;
      els.insights.innerHTML = html ? '<li class="wl-insights__lead">' + escapeHtml(str('heroNews')) + '</li>' + html : '';
    }

    function updateSticky() {
      if (!els.sticky) return;
      var handles = Object.keys(cards);
      var show = mode === 'own' && activeTab !== 'looks' && handles.length > 0 && !heroInView;
      els.sticky.hidden = !show;
      document.body.classList.toggle('wl-sticky-on', show);
      if (!show) return;
      var total = 0;
      handles.forEach(function (h) {
        var data = cardData(cards[h]);
        if (!data || !data.available) return;
        var v = selectedVariant(cards[h]);
        total += v && v.available ? v.price : currentPrice(data) || 0;
      });
      els.stickyText.innerHTML = escapeHtml(str('stickyTotal', { count: '\u00a7', total: formatMoney(total) })).replace('\u00a7', '<b>' + escapeHtml(countText(handles.length)) + '</b>');
      if (els.stickyThumbs) {
        els.stickyThumbs.innerHTML = currentItems().filter(function (i) { return i.img; }).slice(0, 3)
          .map(function (i) { return '<i style="background-image:url(\'' + escapeHtml(i.img) + '\')"></i>'; }).join('');
      }
    }

    if (els.heroActions && els.sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        heroInView = entries[0].isIntersecting;
        updateSticky();
      }).observe(els.heroActions);
    }

    /* ---- "Passer til dine favoritter" (Shopify-anbefalinger) ---- */

    var recsLoaded = false;
    function loadRecs() {
      if (recsLoaded || !els.recs || mode !== 'own') return;
      var ids = currentItems().concat(Store.items()).map(function (i) { return i.id || (dataByHandle[i.handle] || {}).id; }).filter(Boolean);
      ids = ids.filter(function (id, n) { return ids.indexOf(id) === n; }).slice(0, 3);
      if (!ids.length) return;
      recsLoaded = true;
      var limit = toInt(els.recs.getAttribute('data-limit')) || 5;
      var base = (cfg.root || '/').replace(/\/$/, '');
      Promise.all(ids.map(function (id) {
        return fetch(base + '/recommendations/products?product_id=' + id + '&limit=10&section_id=wishlist-recommendations', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (pages) {
        var seen = {};
        var out = [];
        pages.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-wishlist-recs-render] > .grid__item').forEach(function (el) {
            var h = el.getAttribute('data-product-handle');
            if (!h || seen[h] || Store.has(h)) return;
            seen[h] = true;
            out.push(el);
          });
        });
        // Bland anbefalingerne fra de forskellige favoritter
        out = out.slice(0, limit);
        if (!out.length) return;
        els.recsGrid.innerHTML = '';
        out.forEach(function (el) { els.recsGrid.appendChild(document.importNode(el, true)); });
        els.recs.hidden = false;
        syncButtons(els.recsGrid);
        if (window.AOS) { try { AOS.refreshHard(); } catch (e) { /* ignore */ } }
      });
    }

    function moveLabel(handle) {
      var item = Store.get(handle);
      var list = item && item.list ? Store.getList(item.list) : null;
      return list ? listLabel(list) : '+ ' + str('moveToList');
    }

    function updateMovePills() {
      Object.keys(cards).forEach(function (handle) {
        var pill = cards[handle].querySelector('[data-wishlist-move]');
        if (pill) {
          pill.textContent = moveLabel(handle);
          pill.classList.toggle('is-set', !!(Store.get(handle) || {}).list);
        }
      });
    }

    function initCard(el, item) {
      el.classList.remove('is-removing');
      var data = cardData(el);
      if (!data || el._wlInit) {
        if (data) {
          renderStar(el, data.handle);
          updateCard(el);
        }
        return;
      }
      el._wlInit = true;

      if (mode === 'own') {
        // Gem billede/titel til listernes forsider og popup'en
        Store.setMeta(data.handle, { img: data.image, title: data.title, price: currentPrice(data) });
        if (listsOn) {
          var host = el.querySelector('[data-wishlist-card]');
          if (host) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'wl-move';
            pill.setAttribute('data-wishlist-move', data.handle);
            pill.textContent = moveLabel(data.handle);
            host.insertBefore(pill, host.firstChild);
          }
        }
        buildQuick(el, data);
        renderFlag(el, data);
      }
      dataByHandle[data.handle] = data;

      renderNote(el, data.handle, item);
      renderStar(el, data.handle, item);

      var select = el.querySelector('[data-wishlist-variant-select]');
      if (select) {
        var saved = findVariant(data, item && item.variant);
        if (saved && saved.available) select.value = String(saved.id);
        select.addEventListener('change', function () {
          updateCard(el);
          if (mode === 'own' && select.value) Store.setVariant(data.handle, select.value);
        });
      }
      renderWants(el, item);
      renderReserve(el, data.handle);
      updateCard(el);
    }



    /* ---- Topønske (⭐) og ønsket størrelse ---- */

    var STAR_SVG = '<svg aria-hidden="true" focusable="false" class="wl-star__icon" viewBox="0 0 24 24"><path d="M12 2.8l2.8 5.7 6.3.9-4.55 4.43 1.07 6.27L12 17.13 6.38 20.1l1.07-6.27L2.9 9.4l6.3-.9L12 2.8z"/></svg>';

    function isStarred(handle, fallback) {
      if (mode === 'shared') {
        var shared = sharedItems.filter(function (i) { return i.handle === handle; })[0];
        return !!(shared && shared.star);
      }
      var it = Store.get(handle);
      return it ? !!it.star : !!(fallback && fallback.star);
    }

    function renderStar(el, handle, item) {
      var mask = el.querySelector('.grid-product__image-mask, .product-card__image-wrapper');
      if (!mask) return;
      var on = isStarred(handle, item);
      el.classList.toggle('is-top-wish', on);
      var node = mask.querySelector('[data-wishlist-star]');
      if (mode === 'own') {
        if (!node) {
          node = document.createElement('button');
          node.type = 'button';
          node.className = 'wl-star wl-star--' + (cfg.cardPosition || 'top-left');
          node.setAttribute('data-wishlist-star', handle);
          node.innerHTML = STAR_SVG;
          mask.appendChild(node);
        }
        node.classList.toggle('is-active', on);
        node.setAttribute('aria-pressed', on ? 'true' : 'false');
        node.setAttribute('aria-label', on ? str('starRemove') : str('starAdd'));
        node.setAttribute('title', on ? str('starRemove') : str('starAdd'));
      } else {
        if (on && !node) {
          node = document.createElement('span');
          node.className = 'wl-topwish';
          node.setAttribute('data-wishlist-star', handle);
          node.innerHTML = STAR_SVG + '<span>' + escapeHtml(str('topWish')) + '</span>';
          mask.appendChild(node);
        } else if (!on && node) {
          node.parentNode.removeChild(node);
        }
      }
    }

    function sizeWord(name) {
      return /st(ø|o)rr|size|str\.?$/i.test(name || '');
    }

    function renderWants(el, item) {
      var box = el.querySelector('[data-wishlist-wants]');
      var data = cardData(el);
      if (!box || !data) return;
      var variant = mode === 'shared' && data.hasVariants ? findVariant(data, item && item.variant) : null;
      if (!variant) { box.hidden = true; return; }
      var text = sizeWord(data.optionName) ? str('wantsSize', { size: variant.title }) : str('wantsVariant', { variant: variant.title });
      box.innerHTML = '<span>' + escapeHtml(text) +
        (variant.available ? '' : ' <em>(' + escapeHtml(str('wantsSoldOut')) + ')</em>') + '</span>';
      box.classList.toggle('is-soldout', !variant.available);
      box.hidden = false;
    }

    els.grid.addEventListener('click', function (evt) {
      var btn = evt.target.closest('[data-wishlist-star]');
      if (!btn || mode !== 'own' || btn.tagName !== 'BUTTON') return;
      evt.preventDefault();
      var handle = btn.getAttribute('data-wishlist-star');
      var on = !isStarred(handle);
      suppressChange = true;
      Store.setStar(handle, on);
      suppressChange = false;
      toast(on ? str('starAdded') : str('starRemoved'));
      render();
    });

    /* ---- Noter på produkter ---- */

    function itemNote(handle, fallback) {
      if (mode === 'shared') {
        var shared = sharedItems.filter(function (i) { return i.handle === handle; })[0];
        return shared && shared.note ? shared.note : '';
      }
      var it = Store.get(handle);
      return it && it.note ? it.note : (fallback && fallback.note) || '';
    }

    function renderNote(el, handle, item, editing) {
      var box = el.querySelector('[data-wishlist-note]');
      if (!box) return;
      var note = itemNote(handle, item);
      box.classList.toggle('is-editing', !!editing);

      if (editing && mode === 'own') {
        box.hidden = false;
        var id = 'WlNote-' + handle;
        box.innerHTML =
          '<label class="wl-note__label text-label" for="' + escapeHtml(id) + '">' + escapeHtml(str('noteLabel')) + '</label>' +
          '<textarea id="' + escapeHtml(id) + '" class="wl-note__input" rows="2" maxlength="' + MAX_NOTE + '" placeholder="' + escapeHtml(str('notePlaceholder')) + '">' + escapeHtml(note) + '</textarea>' +
          '<div class="wl-note__bar">' +
            '<span class="wl-note__left" aria-live="polite"></span>' +
            '<span class="wl-note__btns">' +
              (note ? '<button type="button" class="wl-note__link" data-note-delete>' + escapeHtml(str('deleteNote')) + '</button>' : '') +
              '<button type="button" class="wl-note__link" data-note-cancel>' + escapeHtml(str('cancel')) + '</button>' +
              '<button type="button" class="btn btn--primary btn--small wl-note__save" data-note-save>' + escapeHtml(str('noteSave')) + '</button>' +
            '</span>' +
          '</div>';
        var ta = box.querySelector('textarea');
        var left = box.querySelector('.wl-note__left');
        var update = function () { left.textContent = str('noteLeft', { count: MAX_NOTE - ta.value.length }); };
        ta.addEventListener('input', update);
        ta.addEventListener('keydown', function (evt) {
          if (evt.key === 'Enter' && !evt.shiftKey) { evt.preventDefault(); saveNote(el, handle, ta.value); }
          if (evt.key === 'Escape') { evt.stopPropagation(); renderNote(el, handle); }
        });
        update();
        setTimeout(function () { ta.focus(); ta.setSelectionRange(ta.value.length, ta.value.length); }, 30);
        return;
      }

      if (note) {
        box.hidden = false;
        box.innerHTML =
          '<p class="wl-note__text"><span class="wl-note__icon" aria-hidden="true">✎</span><span>' + escapeHtml(note) + '</span></p>' +
          (mode === 'own' ? '<button type="button" class="wl-note__link" data-note-edit>' + escapeHtml(str('editNote')) + '</button>' : '');
      } else if (mode === 'own') {
        box.hidden = false;
        box.innerHTML = '<button type="button" class="wl-note__add" data-note-edit>+ ' + escapeHtml(str('addNote')) + '</button>';
      } else {
        box.hidden = true;
        box.innerHTML = '';
      }
    }

    function saveNote(el, handle, text) {
      var had = !!itemNote(handle);
      suppressChange = true;
      Store.setNote(handle, text);
      suppressChange = false;
      renderNote(el, handle);
      var hasNow = !!itemNote(handle);
      if (hasNow) toast(str('noteSaved'));
      else if (had) toast(str('noteDeleted'));
      var focusTarget = el.querySelector('[data-note-edit]');
      if (focusTarget) focusTarget.focus();
    }

    els.grid.addEventListener('click', function (evt) {
      var t = evt.target.closest('[data-note-edit], [data-note-save], [data-note-cancel], [data-note-delete]');
      if (!t || mode !== 'own') return;
      var el = t.closest('.grid__item');
      var handle = el && el.getAttribute('data-wishlist-handle');
      if (!handle) return;
      if (t.hasAttribute('data-note-edit')) renderNote(el, handle, null, true);
      else if (t.hasAttribute('data-note-cancel')) renderNote(el, handle);
      else if (t.hasAttribute('data-note-delete')) saveNote(el, handle, '');
      else saveNote(el, handle, el.querySelector('.wl-note__input').value);
    });

    /* ---- Rendering ---- */

    function updateChrome() {
      var count = mode === 'own' ? Store.count() : Object.keys(cards).length;
      var hasItems = count > 0;
      var busy = !els.loading.hidden;
      var lists = mode === 'own' && listsOn ? Store.lists() : [];
      var list = selectedList ? Store.getList(selectedList) : null;
      var inView = mode === 'own' ? currentItems().length : count;

      els.countText.hidden = !hasItems;
      els.countText.textContent = !hasItems ? ''
        : lists.length ? str('summary', { products: countText(count), lists: lists.length === 1 ? str('listsOne') : str('listsOther', { count: lists.length }) })
        : countText(count);
      els.toolbar.hidden = !hasItems || mode === 'shared' || !list;
      if (els.filterbar) els.filterbar.hidden = mode !== 'own' || !hasItems;
      els.empty.hidden = hasItems || busy;
      root.classList.toggle('is-empty', mode === 'own' && !hasItems && !busy);
      if (els.recs && !hasItems) { els.recs.hidden = true; recsLoaded = false; }
      if (mode === 'shared') updateShareHero(count);
      if (els.share) els.share.hidden = mode !== 'own' || !hasItems || (list && !inView);

      // Toolbar: listens navn og liste-handlinger, når en liste er valgt
      if (els.listTitle) {
        els.listTitle.hidden = !list;
        els.listTitle.innerHTML = list ? escapeHtml(listLabel(list)) + ' <span class="wl-chip">' + escapeHtml(countText(inView)) + '</span>' : '';
      }
      root.querySelectorAll('[data-scope="list"]').forEach(function (b) { b.hidden = mode !== 'own' || !list; });
      root.querySelectorAll('[data-scope="all"]').forEach(function (b) { b.hidden = mode !== 'own' || !!list; });
      root.querySelectorAll('[data-wishlist-add-all]').forEach(function (btn) {
        var m = btn.getAttribute('data-mode');
        btn.hidden = !inView || (!!m && m !== mode);
      });
      if (els.listEmpty) els.listEmpty.hidden = !(list && !inView && !busy);

      // Ønskeseddel-banner
      if (els.gift) {
        var wish = lists.filter(function (l) { return l.type !== 'custom'; })[0];
        var giftBtn = els.gift.querySelector('[data-wishlist-gift-btn]');
        els.gift.hidden = mode !== 'own' || !hasItems || !listsOn || (list && list.type !== 'custom');
        giftBtn.textContent = wish ? giftBtn.getAttribute('data-label-share') : giftBtn.getAttribute('data-label-create');
        giftBtn.setAttribute('data-list', wish ? wish.id : '');
      }
      renderBoards();
      if (typeof updateLookTabs === 'function') updateLookTabs();
      // Login-linjen øverst giver kun mening, når der er noget at gemme – i tom tilstand står den i panelet
      if (els.login && mode === 'own') els.login.hidden = !hasItems;
      els.more.hidden = cursor >= queue.length || !hasItems;
      applyFeature();
      updateHero(hasItems);
      updateSticky();
      if (hasItems) loadRecs();
    }

    var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.1C1.4 8.1 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.6 3.6 4.3 6.9-1.8 4.5-9.3 9.1-9.3 9.1z"/></svg>';

    function renderBoards() {
      if (!els.boards) return;
      var show = mode === 'own' && listsOn && Store.count() > 0;
      els.boards.hidden = !show;
      if (!show) return;
      var all = Store.items().sort(function (a, b) { return b.added - a.added; });
      var html = board('', str('allFavorites'), '', all, '');
      var days = daysToXmas();
      Store.lists().forEach(function (l) {
        var extra = l.type === 'christmas' && days > 0 ? str('listDays', { count: days }) : '';
        html += board(l.id, l.name, LIST_TYPES[l.type] || '', all.filter(function (i) { return i.list === l.id; }), extra);
      });
      if (Store.lists().length < MAX_LISTS) {
        html += '<button type="button" class="wl-board wl-board--new" data-wishlist-new-list>+ ' + escapeHtml(str('newListCard')) + '</button>';
      }
      els.boards.innerHTML = html;
    }

    function board(id, name, emoji, items, extra) {
      var active = (selectedList || '') === id;
      var img = items.filter(function (i) { return i.img; })[0];
      var thumb = img ? '<i style="background-image:url(\'' + escapeHtml(img.img) + '\')"></i>'
        : '<i>' + (emoji ? escapeHtml(emoji) : HEART_SVG) + '</i>';
      if (img && emoji) thumb = '<i>' + escapeHtml(emoji) + '</i>';
      return '<button type="button" class="wl-board' + (active ? ' is-active' : '') + (extra ? ' has-extra' : '') + '" data-wishlist-board="' + id + '" aria-pressed="' + active + '">' +
        thumb +
        '<span class="wl-board__name">' + escapeHtml(name) + '</span>' +
        (extra ? '<em class="wl-board__extra">' + escapeHtml(extra) + '</em>' : '<small class="wl-board__count">' + items.length + '</small>') +
      '</button>';
    }

    /* ---- Delt visning: hero, statistik og sektioner ---- */

    function isWishList() {
      return !!(sharedMeta && sharedMeta.type !== 'custom' && sharedMeta.type !== 'look');
    }

    function updateShareHero(count) {
      if (!els.shareHero) return;
      var stats = els.shareHero.querySelector('[data-share-stats]');
      var top = 0;
      var value = 0;
      Object.keys(cards).forEach(function (handle) {
        if (isStarred(handle)) top++;
        var el = cards[handle];
        var data = cardData(el);
        if (!data || !data.available) return;
        var v = selectedVariant(el) || data.variants.filter(function (x) { return x.available; })[0];
        if (v && v.available) value += v.price;
      });
      var chips = [count === 1 ? str('shareStatItemsOne') : str('shareStatItemsOther', { count: count })];
      if (top) chips.push(top === 1 ? str('shareStatTopOne') : str('shareStatTop', { count: top }));
      if (value) chips.push(str('shareStatValue', { value: formatMoney(value) }));
      if (delCode && shareInfo && !shareInfo.isOwner) {
        var reservedCount = Object.keys(cards).filter(function (h) { return reservedSet[h] || mineSet[h]; }).length;
        if (reservedCount) chips.push(str('shareStatReserved', { count: reservedCount }));
      }
      stats.innerHTML = count ? chips.map(function (c) { return '<li>' + escapeHtml(c) + '</li>'; }).join('') : '';
    }

    function placeSectionHeads() {
      els.grid.querySelectorAll('.wl-sechead').forEach(function (h) { h.parentNode.removeChild(h); });
      if (mode !== 'shared') return;
      var items = Array.prototype.filter.call(els.grid.children, function (c) { return c.hasAttribute('data-wishlist-handle'); });
      var firstTop = items.filter(function (c) { return isStarred(c.getAttribute('data-wishlist-handle')); })[0];
      var firstRest = items.filter(function (c) { return !isStarred(c.getAttribute('data-wishlist-handle')); })[0];
      if (!firstTop) return;
      var head = function (text) {
        var d = document.createElement('div');
        d.className = 'grid__item wl-sechead';
        d.innerHTML = '<h2 class="h3">' + escapeHtml(text) + '</h2>';
        return d;
      };
      els.grid.insertBefore(head(str('shareTopHeading')), firstTop);
      if (firstRest) els.grid.insertBefore(head(str('shareRestHeading')), firstRest);
    }

    function setLoadingState(on) {
      els.loading.hidden = !on;
      if (on) els.empty.hidden = true;
    }

    function render() {
      var token = ++renderToken;
      queue = currentItems();
      cursor = 0;
      cards = {};
      els.grid.innerHTML = '';
      if (!queue.length) {
        setLoadingState(false);
        updateChrome();
        return Promise.resolve();
      }
      return loadNext(token);
    }

    function loadNext(token) {
      token = token || renderToken;
      var batch = queue.slice(cursor, cursor + pageSize);
      cursor += batch.length;
      setLoadingState(true);
      els.more.hidden = true;

      return fetchInOrder(batch, 6).then(function (results) {
        if (token !== renderToken) return;
        var fragment = document.createDocumentFragment();
        results.forEach(function (result, i) {
          var item = batch[i];
          if (result && result.el) {
            result.el.setAttribute('data-wishlist-handle', item.handle);
            cards[item.handle] = result.el;
            fragment.appendChild(result.el);
          } else if (result && result.missing && mode === 'own') {
            // Produktet findes ikke længere (slettet/ikke publiceret) → ryd op
            suppressChange = true;
            Store.remove(item.handle);
            suppressChange = false;
          }
        });
        els.grid.appendChild(fragment);
        results.forEach(function (result, i) {
          if (result && result.el) initCard(result.el, batch[i]);
        });
        placeSectionHeads();
        syncButtons(els.grid);
        if (window.AOS) {
          try { AOS.refreshHard(); } catch (e) { /* ignore */ }
        }
        setLoadingState(false);
        updateChrome();
      });
    }

    function loadAll() {
      if (cursor >= queue.length) return Promise.resolve();
      return loadNext().then(loadAll);
    }

    function removeCard(handle, animate) {
      var el = cards[handle];
      if (!el) return null;
      delete cards[handle];
      var index = Array.prototype.indexOf.call(els.grid.children, el);
      queue = queue.filter(function (i) { return i.handle !== handle; });
      cursor = Math.max(0, Math.min(cursor, queue.length));
      if (animate) {
        el.classList.add('is-removing');
        setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); updateChrome(); }, 300);
      } else if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      return { el: el, index: index };
    }

    function removeWithUndo(handle) {
      var item = Store.get(handle);
      suppressChange = true;
      Store.remove(handle);
      suppressChange = false;
      var removed = removeCard(handle, true);
      updateChrome();

      toast(str('removed'), str('undo'), function () {
        if (!item) return;
        suppressChange = true;
        Store.add(item);
        suppressChange = false;
        if (removed && removed.el) {
          removed.el.classList.remove('is-removing');
          var ref = els.grid.children[removed.index] || null;
          els.grid.insertBefore(removed.el, ref);
          cards[handle] = removed.el;
          queue.splice(Math.min(removed.index, queue.length), 0, item);
          cursor++;
          syncButtons(els.grid);
        }
        updateChrome();
      });
    }

    /* ---- Variant-modal ---- */

    var variantSession = null;

    function openVariantModal(entries, readyLines, sourceForm, sourceButton) {
      var list = document.querySelector('[data-wishlist-variant-list]');
      var note = document.querySelector('[data-wishlist-variant-note]');
      var errorEl = document.querySelector('[data-wishlist-variant-error]');
      var submit = document.querySelector('[data-wishlist-variant-submit]');
      if (!list || !submit) return;

      variantSession = {
        entries: entries,
        ready: readyLines || [],
        selected: {},
        sourceForm: sourceForm,
        sourceButton: sourceButton
      };

      list.innerHTML = entries.map(function (el) {
        var data = cardData(el);
        var priceVariant = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
        var price = priceVariant.compareAtPrice > priceVariant.price
          ? '<s>' + formatMoney(priceVariant.compareAtPrice) + '</s>' + formatMoney(priceVariant.price)
          : formatMoney(priceVariant.price);
        var pills = data.variants.map(function (v) {
          return '<button type="button" class="wishlist-pill" data-variant-pill data-handle="' + escapeHtml(data.handle) +
            '" data-variant="' + v.id + '" aria-pressed="false"' + (v.available ? '' : ' disabled') + '>' +
            escapeHtml(v.title) + '</button>';
        }).join('');
        return '<div class="wishlist-variant" data-handle="' + escapeHtml(data.handle) + '">' +
          (data.image ? '<img class="wishlist-variant__image" src="' + escapeHtml(data.image) + '" alt="" loading="lazy" width="72">' : '<span></span>') +
          '<div>' +
            '<p class="wishlist-variant__title">' + escapeHtml(data.title) + '</p>' +
            '<p class="wishlist-variant__price" data-variant-price>' + price + '</p>' +
            '<p class="wishlist-variant__label">' + escapeHtml(data.selectLabel) + '</p>' +
            '<div class="wishlist-variant__options" role="group" aria-label="' + escapeHtml(data.selectLabel) + '">' + pills + '</div>' +
          '</div>' +
        '</div>';
      }).join('');

      note.hidden = entries.length < 2;
      errorEl.hidden = true;
      updateVariantSubmit();
      openModal('WishlistVariantModal');
    }

    function updateVariantSubmit() {
      var submit = document.querySelector('[data-wishlist-variant-submit]');
      if (!submit || !variantSession) return;
      var n = Object.keys(variantSession.selected).length;
      submit.disabled = n === 0;
    }

    document.addEventListener('click', function (evt) {
      var pill = evt.target.closest && evt.target.closest('[data-variant-pill]');
      if (!pill || !variantSession) return;
      var handle = pill.getAttribute('data-handle');
      var variantId = toInt(pill.getAttribute('data-variant'));
      var row = pill.closest('.wishlist-variant');
      row.querySelectorAll('[data-variant-pill]').forEach(function (p) {
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });
      variantSession.selected[handle] = variantId;

      // Opdatér pris i modal og spejl valget på kortet
      var el = cards[handle];
      var data = el && cardData(el);
      var variant = data && findVariant(data, variantId);
      if (variant) {
        var priceEl = row.querySelector('[data-variant-price]');
        priceEl.innerHTML = variant.compareAtPrice > variant.price
          ? '<s>' + formatMoney(variant.compareAtPrice) + '</s>' + formatMoney(variant.price)
          : formatMoney(variant.price);
        var select = el.querySelector('[data-wishlist-variant-select]');
        if (select) {
          select.value = String(variantId);
          updateCard(el);
        }
        if (mode === 'own') Store.setVariant(handle, variantId);
      }
      updateVariantSubmit();
    });

    document.addEventListener('click', function (evt) {
      var submit = evt.target.closest && evt.target.closest('[data-wishlist-variant-submit]');
      if (!submit || !variantSession) return;
      var session = variantSession;
      var lines = session.ready.slice();
      Object.keys(session.selected).forEach(function (handle) {
        lines.push({ id: session.selected[handle], quantity: 1 });
      });
      if (!lines.length) return;

      var errorEl = document.querySelector('[data-wishlist-variant-error]');
      setLoading(submit, true);
      addLinesToCart(lines)
        .then(function (result) {
          setLoading(submit, false);
          variantSession = null;
          closeModal('WishlistVariantModal');
          if (lines.length > 1) toast(str('addedAll', { count: result.items.length }));
          afterCartAdd(result, session.sourceForm, session.sourceButton || submit);
        })
        .catch(function (err) {
          setLoading(submit, false);
          errorEl.textContent = err.message || str('error');
          errorEl.hidden = false;
        });
    });

    /* ---- Læg i kurv fra kort ---- */

    els.grid.addEventListener('submit', function (evt) {
      var form = evt.target.closest('[data-wishlist-form]');
      if (!form) return;
      evt.preventDefault();
      var el = form.closest('.grid__item');
      var data = cardData(el);
      var button = form._wlQuick || form.querySelector('[data-wishlist-add]');
      form._wlQuick = null;
      var variant = selectedVariant(el);

      if (data && data.hasVariants && !variant) {
        openVariantModal([el], [], form, button);
        return;
      }
      if (!variant || !variant.available) return;

      var errorEl = form.querySelector('[data-wishlist-error]');
      setLoading(button, true);
      addLinesToCart([{ id: variant.id, quantity: 1 }])
        .then(function (result) {
          setLoading(button, false);
          updateCard(el);
          afterCartAdd(result, form, button);
          if (delCode && shareInfo && !shareInfo.isOwner && data && !mineSet[data.handle] && !reservedSet[data.handle]) {
            var h = data.handle;
            setTimeout(function () { toast(str('reserveAsk'), str('reserveAskYes'), function () { reserve(h, 'reserve'); }); }, 400);
          }
        })
        .catch(function (err) {
          setLoading(button, false);
          updateCard(el);
          if (errorEl) {
            errorEl.textContent = err.message || str('error');
            errorEl.hidden = false;
          }
        });
    });

    els.grid.addEventListener('click', function (evt) {
      var rb = evt.target.closest && evt.target.closest('[data-wl-reserve], [data-wl-release]');
      if (rb) {
        evt.preventDefault();
        if (rb.hasAttribute('data-wl-reserve')) reserve(rb.getAttribute('data-wl-reserve'), 'reserve', rb);
        else reserve(rb.getAttribute('data-wl-release'), 'release', rb);
        return;
      }
    });

    els.grid.addEventListener('click', function (evt) {
      var t = evt.target.closest && evt.target.closest('[data-wl-size], [data-wl-quick-add]');
      if (!t) return;
      evt.preventDefault();
      evt.stopPropagation();
      var el = t.closest('.grid__item');
      if (t.hasAttribute('data-wl-size')) {
        var select = el.querySelector('[data-wishlist-variant-select]');
        if (!select) return;
        select.value = t.getAttribute('data-wl-size');
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var form = el.querySelector('[data-wishlist-form]');
      if (!form) return;
      form._wlQuick = t;
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, true);

    function setSort(value, scroll) {
      sortMode = value || 'newest';
      if (els.sort) els.sort.value = sortMode;
      render();
      if (scroll && els.filterbar) els.filterbar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (els.sort) {
      els.sort.addEventListener('change', function () { setSort(els.sort.value); });
    }

    if (els.insights) {
      els.insights.addEventListener('click', function (evt) {
        var t = evt.target.closest('[data-wl-insight]');
        if (!t) return;
        var action = t.getAttribute('data-wl-insight');
        if (action === 'sale') setSort('sale', true);
        else if (action.indexOf('list:') === 0) { selectList(action.slice(5)); if (els.filterbar) els.filterbar.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }

    /* ---- Toolbar ---- */

    function addAll(button) {
      setLoading(button, true);
      loadAll().then(function () {
        setLoading(button, false);
        var ready = [];
        var needs = [];
        Object.keys(cards).forEach(function (handle) {
          var el = cards[handle];
          var data = cardData(el);
          if (!data || !data.available) return;
          var variant = selectedVariant(el);
          if (variant && variant.available) {
            ready.push({ id: variant.id, quantity: 1 });
          } else if (data.hasVariants && !variant) {
            needs.push(el);
          }
        });
        // Bevar rækkefølgen fra griddet
        needs.sort(function (a, b) {
          return Array.prototype.indexOf.call(els.grid.children, a) - Array.prototype.indexOf.call(els.grid.children, b);
        });

        if (needs.length) {
          openVariantModal(needs, ready, null, button);
          return;
        }
        if (!ready.length) {
          toast(str('nothingToAdd'));
          return;
        }
        setLoading(button, true);
        addLinesToCart(ready)
          .then(function (result) {
            setLoading(button, false);
            toast(str('addedAll', { count: result.items.length }));
            afterCartAdd(result, null, button);
          })
          .catch(function (err) {
            setLoading(button, false);
            toast(err.message || str('error'));
          });
      }, function () {
        setLoading(button, false);
        toast(str('error'));
      });
    }

    /* ---- "Jeg køber den" (kun på korte links) ---- */

    function browserId() { return getBrowserId(); }

    function shareApi(path) {
      return cfg.shareProxy.replace(/\/$/, '') + '/share/' + delCode + (path || '');
    }

    function renderReserve(el, handle) {
      if (!delCode || !shareInfo || shareInfo.isOwner) return;
      var host = el.querySelector('[data-wishlist-card]');
      if (!host) return;
      var box = host.querySelector('.wl-reserve');
      if (!box) {
        box = document.createElement('div');
        box.className = 'wl-reserve';
        host.appendChild(box);
      }
      var mine = !!mineSet[handle];
      var other = !mine && !!reservedSet[handle];
      el.classList.toggle('is-reserved', other);
      box.setAttribute('data-state', mine ? 'mine' : other ? 'other' : 'open');
      if (mine) {
        box.innerHTML = '<p class="wl-reserve__status">' + escapeHtml(str('reservedMine')) + '</p>' +
          '<button type="button" class="wl-reserve__undo text-link" data-wl-release="' + escapeHtml(handle) + '">' + escapeHtml(str('reserveUndo')) + '</button>';
      } else if (other) {
        box.innerHTML = '<p class="wl-reserve__status">' + escapeHtml(str('reservedOther')) + '</p>';
      } else {
        box.innerHTML = '<button type="button" class="btn btn--secondary btn--small btn--full wl-reserve__btn" data-wl-reserve="' + escapeHtml(handle) + '">' + escapeHtml(str('reserveBtn')) + '</button>' +
          '<p class="wl-reserve__hint">' + escapeHtml(str('reserveHint')) + '</p>';
      }
    }

    function reserve(handle, action, button) {
      if (button) setLoading(button, true);
      return fetch(shareApi('/reserve'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ handle: handle, by: browserId(), action: action || 'reserve' })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (button) setLoading(button, false);
        if (action === 'release') {
          delete mineSet[handle];
          delete reservedSet[handle];
        } else if (res.ok) {
          mineSet[handle] = true;
          toast(str('reserveDone'));
        } else if (res.taken) {
          reservedSet[handle] = true;
          toast(str('reserveTaken'));
        } else {
          toast(str('error'));
        }
        if (cards[handle]) renderReserve(cards[handle], handle);
        updateChrome();
      }).catch(function () {
        if (button) setLoading(button, false);
        toast(str('error'));
      });
    }

    function loadSharedFromServer() {
      return fetch(shareApi('?by=' + browserId()), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (data) {
          if (!data || data.gone) return null;
          shareInfo = data;
          sharedItems = normalizeItems(data.items || []);
          sharedMeta = data.list ? { name: String(data.list.name || '').slice(0, 40), type: SHARE_TYPES.hasOwnProperty(data.list.type) ? data.list.type : 'custom' } : null;
          (data.reserved || []).forEach(function (h) { reservedSet[h] = true; });
          (data.mine || []).forEach(function (h) { mineSet[h] = true; });
          return data;
        });
    }

    /* ---- Påmindelse om størrelse, når listen deles ---- */

    var sizeCheckEl = document.querySelector('[data-wishlist-sizecheck]');
    var sizeCheckHandles = [];

    function savedVariant(handle, data) {
      var item = Store.get(handle);
      var v = item && findVariant(data, item.variant);
      return v || null;
    }

    function renderSizeCheck(reset) {
      if (!sizeCheckEl) return;
      if (reset) {
        // Hvilke ønsker i den delte visning mangler størrelse (gemmes, så de bliver stående med ✓)
        sizeCheckHandles = currentItems().filter(function (i) {
          var el = cards[i.handle];
          var data = el && cardData(el);
          return data && data.hasVariants && data.available && !savedVariant(i.handle, data);
        }).map(function (i) { return i.handle; });
      }
      if (!sizeCheckHandles.length) {
        sizeCheckEl.hidden = true;
        sizeCheckEl.innerHTML = '';
        return;
      }
      var missing = 0;
      var rows = sizeCheckHandles.map(function (handle) {
        var el = cards[handle];
        var data = el && cardData(el);
        if (!data) return '';
        var chosen = savedVariant(handle, data);
        if (!chosen) missing++;
        var labels = shortVariantLabels(data);
        var pills = data.variants.map(function (v) {
          var on = chosen && chosen.id === v.id;
          return '<button type="button" class="wl-sizecheck__pill' + (on ? ' is-on' : '') + '" data-wl-sizecheck="' + escapeHtml(handle) + '" data-variant="' + v.id + '" aria-pressed="' + !!on + '"' + (v.available ? '' : ' disabled') + '>' + escapeHtml(labels.byId[v.id] || v.title) + '</button>';
        }).join('');
        return '<li class="wl-sizecheck__item' + (chosen ? ' is-done' : '') + '">' +
          (data.image ? '<img src="' + escapeHtml(data.image) + '" alt="" width="44" loading="lazy">' : '<span class="wl-sizecheck__noimg"></span>') +
          '<div class="wl-sizecheck__body"><p class="wl-sizecheck__name">' + (chosen ? '✓ ' : '') + escapeHtml(data.title) + '</p>' +
          '<div class="wl-sizecheck__pills" role="group" aria-label="' + escapeHtml(data.selectLabel || '') + '">' + pills + '</div></div></li>';
      }).join('');
      sizeCheckEl.hidden = false;
      sizeCheckEl.innerHTML = '<div class="wl-sizecheck__head"></div><ul class="wl-sizecheck__list">' + rows + '</ul>';
      updateSizeCheckHead(missing);
    }

    function updateSizeCheckHead(missing) {
      var head = sizeCheckEl.querySelector('.wl-sizecheck__head');
      sizeCheckEl.classList.toggle('is-done', missing === 0);
      head.innerHTML = missing
        ? '<p class="wl-sizecheck__title">⚠️ ' + escapeHtml(missing === 1 ? str('sizeCheckOne') : str('sizeCheckOther', { count: missing })) + '</p>' +
          '<p class="wl-sizecheck__text">' + escapeHtml(str('sizeCheckText')) + '</p>'
        : '<p class="wl-sizecheck__title">✓ ' + escapeHtml(str('sizeCheckDone')) + '</p>';
    }

    if (sizeCheckEl) {
      sizeCheckEl.addEventListener('click', function (evt) {
        var b = evt.target.closest('[data-wl-sizecheck]');
        if (!b || b.disabled) return;
        var handle = b.getAttribute('data-wl-sizecheck');
        var id = b.getAttribute('data-variant');
        Store.setVariant(handle, id);
        var el = cards[handle];
        var select = el && el.querySelector('[data-wishlist-variant-select]');
        if (select) { select.value = id; updateCard(el); }
        // Opdatér på stedet (ikke gen-tegne), så modal'en ikke tror, der blev klikket udenfor
        var item = b.closest('.wl-sizecheck__item');
        item.querySelectorAll('[data-wl-sizecheck]').forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-on', on);
          x.setAttribute('aria-pressed', on);
        });
        if (!item.classList.contains('is-done')) {
          item.classList.add('is-done');
          var nm = item.querySelector('.wl-sizecheck__name');
          nm.textContent = '✓ ' + nm.textContent;
        }
        updateSizeCheckHead(sizeCheckEl.querySelectorAll('.wl-sizecheck__item:not(.is-done)').length);
        // Det lange link indeholder størrelserne – det korte link læser dem fra serveren
        var input = document.querySelector('[data-wishlist-share-url]');
        if (input && input.value.indexOf('favoritter=') > -1) input.value = shareUrl();
        Store.push();
      });
    }

    var shortLinkCache = {};
    function shortShareUrl() {
      // Linket peger på listen på serveren og opdaterer sig selv.
      // Kunder, der er logget ind, gemmes på kontoen – gæster på app-installationen.
      if (!cfg.shareProxy) return Promise.resolve(null);
      var key = selectedList || '';
      if (shortLinkCache[key]) return Promise.resolve(shortLinkCache[key]);
      var create = cfg.customerId && cfg.proxy
        ? fetch(cfg.shareProxy.replace(/\/$/, '') + '/share', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ list: key })
          }).then(function (r) { return r.ok ? r.json() : null; })
        : guestShareCreate(key).then(function (code) { return code ? { code: code } : null; });
      return create.then(function (res) {
        if (!res || !res.code) return null;
        var long = new URL(shareUrl());
        var url = long.origin + cfg.shareProxy.replace(/\/$/, '') + '/s/' + res.code;
        var preview = long.searchParams.get('preview_theme_id');
        if (preview) url += '?preview_theme_id=' + encodeURIComponent(preview);
        shortLinkCache[key] = url;
        return url;
      }).catch(function () { return null; });
    }

    function shareUrl() {
      // Live-tema: altid butikkens primære domæne (shop.url) – ikke *.myshopify.com.
      // Upubliceret tema (preview): nuværende domæne + preview_theme_id, ellers åbner
      // linket det live tema, som endnu ikke har wishlist-siden.
      var theme = window.Shopify && window.Shopify.theme;
      var isPreview = !!(theme && theme.role && theme.role !== 'main' && theme.id);
      var origin = window.location.origin;
      if (!isPreview) {
        try {
          if (cfg.shareOrigin) origin = new URL(cfg.shareOrigin).origin;
        } catch (e) { /* brug nuværende domæne */ }
      }
      var url = new URL(cfg.pageUrl, origin);
      var list = selectedList ? Store.getList(selectedList) : null;
      var value = currentItems().map(function (i) {
        return encodeURIComponent(i.handle) +
          (i.variant || i.star ? ':' + (i.variant || '') : '') +
          (i.star ? ':s' : '') +
          (i.note ? '~' + encodeURIComponent(i.note) : '');
      }).join(',');
      return url.origin + url.pathname + '?favoritter=' + value +
        (list ? '&liste=' + encodeURIComponent(list.name) + '&type=' + list.type : '') +
        (isPreview ? '&preview_theme_id=' + encodeURIComponent(theme.id) : '');
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var input = document.querySelector('[data-wishlist-share-url]');
        input.focus();
        input.select();
        try {
          document.execCommand('copy') ? resolve() : reject();
        } catch (e) {
          reject(e);
        }
      });
    }

    root.addEventListener('click', function (evt) {
      var t = evt.target.closest('button');
      if (!t) return;

      if (t.hasAttribute('data-wishlist-share')) {
        var input = document.querySelector('[data-wishlist-share-url]');
        var status = document.querySelector('[data-wishlist-copy-status]');
        var nativeBtn = document.querySelector('[data-wishlist-native-share]');
        input.value = shareUrl();
        status.textContent = '';
        nativeBtn.hidden = !navigator.share;
        renderSizeCheck(true);
        openModal('WishlistShareModal');
        setTimeout(function () { input.select(); }, 150);
        if (cfg.shareProxy) {
          status.textContent = str('shareLinkMaking');
          // Sørg for, at serveren har den nyeste liste, før linket deles
          Store.push();
          shortShareUrl().then(function (short) {
            status.textContent = short ? str('shareLinkLive') : '';
            if (short) {
              input.value = short;
              input.select();
            }
          });
        }
      } else if (t.hasAttribute('data-wishlist-clear')) {
        openModal('WishlistClearModal');
      } else if (t.hasAttribute('data-wishlist-add-all')) {
        addAll(t);
      } else if (t.hasAttribute('data-wishlist-load-more')) {
        loadNext();
      } else if (t.hasAttribute('data-wishlist-board')) {
        selectList(t.getAttribute('data-wishlist-board') || null);
      } else if (t.hasAttribute('data-wishlist-new-list')) {
        ListPopup.create(null, function (list) { selectList(list.id); });
      } else if (t.hasAttribute('data-wishlist-rename')) {
        ListPopup.rename(selectedList);
      } else if (t.hasAttribute('data-wishlist-delete-list')) {
        ListPopup.confirmDelete(selectedList);
      } else if (t.hasAttribute('data-wishlist-show-all')) {
        selectList(null);
      } else if (t.hasAttribute('data-wishlist-move')) {
        var mh = t.getAttribute('data-wishlist-move');
        var it = Store.get(mh) || {};
        ListPopup.move(mh, { img: it.img, title: it.title });
      } else if (t.hasAttribute('data-wishlist-gift-btn')) {
        var wishId = t.getAttribute('data-list');
        if (wishId) {
          selectList(wishId);
          setTimeout(function () { var sb = root.querySelector('[data-wishlist-share]'); if (sb) sb.click(); }, 50);
        } else {
          ListPopup.create('wish', function (list) { selectList(list.id); });
        }
      } else if (t.hasAttribute('data-wishlist-save-all')) {
        sharedItems.forEach(function (item) {
          if (!Store.has(item.handle)) Store.add(Object.assign({}, item, { added: Date.now() }));
        });
        toast(str('savedAll'));
      }
    });

    document.addEventListener('click', function (evt) {
      var t = evt.target.closest && evt.target.closest('button');
      if (!t) return;

      if (t.hasAttribute('data-wishlist-clear-confirm')) {
        suppressChange = true;
        Store.clear();
        suppressChange = false;
        closeModal('WishlistClearModal');
        render();
      } else if (t.hasAttribute('data-wishlist-copy')) {
        var input = document.querySelector('[data-wishlist-share-url]');
        var status = document.querySelector('[data-wishlist-copy-status]');
        copyText(input.value).then(function () {
          status.textContent = str('copied');
        }, function () {
          input.select();
        });
      } else if (t.hasAttribute('data-wishlist-native-share')) {
        navigator.share({
          title: str('shareTitle'),
          url: document.querySelector('[data-wishlist-share-url]').value
        }).catch(function () { /* afbrudt af brugeren */ });
      }
    });

    /* ---- Ændringer udefra (andre faner, header osv.) ---- */

    document.addEventListener('wishlist:change', function (evt) {
      if (mode !== 'own' || suppressChange) return;
      var detail = evt.detail || {};
      if (detail.action === 'variant') return;
      if (detail.action === 'star') { render(); return; }
      if (detail.action === 'note') {
        if (cards[detail.handle]) renderNote(cards[detail.handle], detail.handle);
        return;
      }
      if (detail.action === 'lists') {
        if (selectedList && !Store.getList(selectedList)) { selectList(null); return; }
        updateMovePills();
        updateChrome();
        return;
      }
      if (detail.action === 'list') {
        var moved = Store.get(detail.handle);
        if (selectedList && cards[detail.handle] && (!moved || moved.list !== selectedList)) {
          removeCard(detail.handle, true);
        }
        updateMovePills();
        updateChrome();
        return;
      }
      if (detail.action === 'remove' && cards[detail.handle]) {
        removeCard(detail.handle, true);
        updateChrome();
        return;
      }
      render();
    });


    /* ---- Sammensæt et look ---- */

    var looksRoot = root.querySelector('[data-wishlist-looks]');
    var tabsEl = root.querySelector('[data-wishlist-tabs]');
    var looksOn = !!cfg.looks && !!looksRoot && mode === 'own';
    var activeTab = 'favorites';
    var currentLook = null;
    var lookFilter = 'all';
    var lookData = {};      // handle -> produktdata (fra temaets kort)
    var lookLoading = null;

    function updateLookTabs() {
      if (!tabsEl) return;
      var show = looksOn && Store.count() > 0;
      tabsEl.hidden = !show;
      if (!show && activeTab === 'looks') setTab('favorites');
    }

    function setTab(name) {
      if (!looksOn) return;
      activeTab = name === 'looks' ? 'looks' : 'favorites';
      root.classList.toggle('is-looks', activeTab === 'looks');
      looksRoot.hidden = activeTab !== 'looks';
      tabsEl.querySelectorAll('[data-wishlist-tab]').forEach(function (t) {
        var on = t.getAttribute('data-wishlist-tab') === activeTab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      try { history.replaceState(null, '', window.location.pathname + window.location.search + (activeTab === 'looks' ? '#looks' : (selectedList ? '#liste=' + selectedList : ''))); } catch (e) { /* ignore */ }
      if (activeTab === 'looks') loadLookData();
    }

    function loadLookData() {
      var missing = Store.items().filter(function (i) { return !lookData[i.handle]; });
      renderLooks();
      if (!missing.length) return Promise.resolve();
      if (lookLoading) return lookLoading;
      lookLoading = fetchInOrder(missing, 6).then(function (results) {
        results.forEach(function (r, n) {
          if (r && r.el) {
            var data = cardData(r.el);
            if (data) { data._el = r.el; lookData[missing[n].handle] = data; }
          }
        });
        lookLoading = null;
        renderLooks();
      });
      return lookLoading;
    }

    function lookVariant(handle) {
      var data = lookData[handle];
      if (!data) return null;
      var item = Store.get(handle) || {};
      if (!data.hasVariants) return data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
      return findVariant(data, item.variant);
    }

    function lookPrice(handle) {
      var data = lookData[handle];
      if (!data) return { price: 0, compare: 0 };
      var v = lookVariant(handle) || data.variants.filter(function (x) { return x.available; })[0] || data.variants[0];
      return { price: v ? v.price : 0, compare: v && v.compareAtPrice > v.price ? v.compareAtPrice : (v ? v.price : 0) };
    }

    function ensureLook() {
      if (currentLook && Store.getLook(currentLook)) return currentLook;
      var look = Store.createLook(str('lookDefaultName') + (Store.looks().length ? ' ' + (Store.looks().length + 1) : ''));
      currentLook = look ? look.id : null;
      return currentLook;
    }

    function renderLooks() {
      if (!looksOn || activeTab !== 'looks') return;
      var looks = Store.looks();
      if (currentLook && !Store.getLook(currentLook)) currentLook = null;
      if (!currentLook && looks.length) currentLook = looks[0].id;
      var look = currentLook ? Store.getLook(currentLook) : null;
      var items = look ? look.items : [];

      // Vælg look
      var chooser = looksRoot.querySelector('[data-look-chooser]');
      chooser.innerHTML = looks.map(function (l) {
        var on = l.id === currentLook;
        return '<button type="button" class="wl-chipbtn' + (on ? ' is-active' : '') + '" data-look-select="' + l.id + '" aria-pressed="' + on + '">' +
          '✨ ' + escapeHtml(l.name) + ' <small>' + l.items.length + '</small></button>';
      }).join('') + (looks.length < MAX_LOOKS ? '<button type="button" class="wl-chipbtn wl-chipbtn--new" data-look-new>' + escapeHtml(str('lookNew')) + '</button>' : '');

      // Navn
      var nameInput = looksRoot.querySelector('[data-look-name]');
      if (document.activeElement !== nameInput) nameInput.value = look ? look.name : '';
      looksRoot.querySelector('[data-look-delete]').hidden = !look;

      // Moodboard
      var board = looksRoot.querySelector('[data-look-board]');
      // Lige store felter i rækker af 3 (3 eller 6 felter)
      var slots = Math.min(MAX_LOOK_ITEMS, Math.max(3, Math.ceil((items.length + 1) / 3) * 3));
      var html = '';
      for (var n = 0; n < slots; n++) {
        var handle = items[n];
        if (handle) {
          var data = lookData[handle];
          var item = Store.get(handle) || {};
          var img = (data && data.image) || item.img || '';
          var v = lookVariant(handle);
          var label = [data && data.type, v && data && data.hasVariants ? 'Str. ' + v.title : ''].filter(Boolean).join(' · ');
          html += '<div class="wl-slot' + (n === 0 ? ' wl-slot--hero' : '') + '" style="' + (img ? 'background-image:url(\'' + escapeHtml(img) + '\')' : '') + '">' +
            '<button type="button" class="wl-slot__x" data-look-remove="' + escapeHtml(handle) + '" aria-label="' + escapeHtml(str('lookRemoveItem')) + '">×</button>' +
            (label ? '<span class="wl-slot__label">' + escapeHtml(label) + '</span>' : '') +
            '<span class="visually-hidden">' + escapeHtml((data && data.title) || item.title || handle) + '</span>' +
          '</div>';
        } else {
          html += '<button type="button" class="wl-slot wl-slot--empty' + (n === 0 ? ' wl-slot--hero' : '') + '" data-look-focus>' +
            '<span class="wl-slot__plus" aria-hidden="true">+</span><span>' + escapeHtml(str('lookSlotEmpty')) + '</span></button>';
        }
      }
      board.innerHTML = html;
      board.setAttribute('data-count', items.length);

      // Opsummering
      var total = 0, compare = 0;
      items.forEach(function (h) { var p = lookPrice(h); total += p.price; compare += p.compare; });
      var parts = items.length === 1 ? str('lookPartsOne') : str('lookPartsOther', { count: items.length });
      looksRoot.querySelector('[data-look-total]').innerHTML = items.length
        ? '<span>' + escapeHtml(str('lookTotal', { name: '“' + (look ? look.name : '') + '”', parts: parts })) + '</span>' +
          '<b>' + (compare > total ? '<s>' + formatMoney(compare) + '</s> ' : '') + formatMoney(total) + '</b>'
        : '<span>' + escapeHtml(str('lookSlotHint')) + '</span>';
      looksRoot.querySelector('[data-look-buy]').disabled = !items.length;
      looksRoot.querySelector('[data-look-share]').disabled = !items.length;

      // Filtre efter produkttype
      var favs = Store.items().sort(function (a, b) { return b.added - a.added; });
      var types = [];
      favs.forEach(function (i) { var d = lookData[i.handle]; if (d && d.type && types.indexOf(d.type) === -1) types.push(d.type); });
      if (lookFilter !== 'all' && types.indexOf(lookFilter) === -1) lookFilter = 'all';
      looksRoot.querySelector('[data-look-filters]').innerHTML = types.length > 1
        ? ['all'].concat(types).map(function (t) {
            return '<button type="button" class="wl-chipbtn wl-chipbtn--sm' + (lookFilter === t ? ' is-active' : '') + '" data-look-filter="' + escapeHtml(t) + '">' +
              escapeHtml(t === 'all' ? str('lookFilterAll') : t) + '</button>';
          }).join('')
        : '';

      // Vælger
      var picker = looksRoot.querySelector('[data-look-picker]');
      picker.innerHTML = favs.filter(function (i) {
        var d = lookData[i.handle];
        return lookFilter === 'all' || (d && d.type === lookFilter);
      }).map(function (i) {
        var d = lookData[i.handle];
        var inLook = items.indexOf(i.handle) > -1;
        var img = (d && d.image) || i.img || '';
        var p = lookPrice(i.handle);
        return '<div class="wl-pick' + (inLook ? ' is-in' : '') + (d && !d.available ? ' is-soldout' : '') + '">' +
          '<button type="button" class="wl-pick__img" data-look-toggle="' + escapeHtml(i.handle) + '" aria-pressed="' + inLook + '" style="' + (img ? 'background-image:url(\'' + escapeHtml(img) + '\')' : '') + '">' +
            '<span class="wl-pick__btn" aria-hidden="true">' + (inLook ? '✓' : '+') + '</span>' +
            '<span class="visually-hidden">' + escapeHtml((d && d.title) || i.title || i.handle) + '</span>' +
          '</button>' +
          '<p class="wl-pick__t">' + escapeHtml((d && d.title) || i.title || '') + '</p>' +
          '<p class="wl-pick__p">' + (d ? (d.available ? formatMoney(p.price) : escapeHtml(str('soldOut'))) : '&nbsp;') + '</p>' +
        '</div>';
      }).join('');
    }

    function lookShareUrl(look) {
      var theme = window.Shopify && window.Shopify.theme;
      var isPreview = !!(theme && theme.role && theme.role !== 'main' && theme.id);
      var origin = window.location.origin;
      if (!isPreview) { try { if (cfg.shareOrigin) origin = new URL(cfg.shareOrigin).origin; } catch (e) { /* ignore */ } }
      var url = new URL(cfg.pageUrl, origin);
      var value = look.items.map(function (h) {
        var it = Store.get(h) || {};
        return encodeURIComponent(h) + (it.variant ? ':' + it.variant : '');
      }).join(',');
      return url.origin + url.pathname + '?favoritter=' + value + '&liste=' + encodeURIComponent(look.name) + '&type=look' +
        (isPreview ? '&preview_theme_id=' + encodeURIComponent(theme.id) : '');
    }

    function buyLook(button) {
      var look = currentLook && Store.getLook(currentLook);
      if (!look || !look.items.length) return;
      var ready = [];
      var needs = [];
      look.items.forEach(function (h) {
        var d = lookData[h];
        if (!d || !d.available) return;
        var v = lookVariant(h);
        if (v && v.available) ready.push({ id: v.id, quantity: 1 });
        else if (d.hasVariants && d._el) needs.push(d._el);
      });
      if (needs.length) { openVariantModal(needs, ready, null, button); return; }
      if (!ready.length) { toast(str('nothingToAdd')); return; }
      setLoading(button, true);
      addLinesToCart(ready).then(function (result) {
        setLoading(button, false);
        toast(str('addedAll', { count: result.items.length }));
        afterCartAdd(result, null, button);
      }, function (err) {
        setLoading(button, false);
        toast(err.message || str('error'));
      });
    }

    if (looksOn) {
      tabsEl.addEventListener('click', function (evt) {
        var t = evt.target.closest('[data-wishlist-tab]');
        if (t) setTab(t.getAttribute('data-wishlist-tab'));
      });

      looksRoot.addEventListener('click', function (evt) {
        var t = evt.target.closest('button');
        if (!t) return;
        if (t.hasAttribute('data-look-select')) {
          currentLook = t.getAttribute('data-look-select');
          renderLooks();
        } else if (t.hasAttribute('data-look-new')) {
          var look = Store.createLook(str('lookDefaultName') + ' ' + (Store.looks().length + 1));
          if (look) { currentLook = look.id; renderLooks(); var ni = looksRoot.querySelector('[data-look-name]'); ni.focus(); ni.select(); }
        } else if (t.hasAttribute('data-look-delete')) {
          Store.deleteLook(currentLook);
          currentLook = null;
          toast(str('lookDeleted'));
        } else if (t.hasAttribute('data-look-toggle') || t.hasAttribute('data-look-remove')) {
          var handle = t.getAttribute('data-look-toggle') || t.getAttribute('data-look-remove');
          var id = ensureLook();
          if (!id) return;
          var res = Store.toggleLookItem(id, handle);
          if (res === 'full') toast(str('lookFull'));
        } else if (t.hasAttribute('data-look-focus')) {
          var picker = looksRoot.querySelector('.wl-looks__picker');
          if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (t.hasAttribute('data-look-filter')) {
          lookFilter = t.getAttribute('data-look-filter');
          renderLooks();
        } else if (t.hasAttribute('data-look-buy')) {
          buyLook(t);
        } else if (t.hasAttribute('data-look-share')) {
          var cur = currentLook && Store.getLook(currentLook);
          if (!cur) return;
          var input = document.querySelector('[data-wishlist-share-url]');
          var status = document.querySelector('[data-wishlist-copy-status]');
          var nativeBtn = document.querySelector('[data-wishlist-native-share]');
          input.value = lookShareUrl(cur);
          status.textContent = '';
          var sc = document.querySelector('[data-wishlist-sizecheck]');
          if (sc) sc.hidden = true;
          nativeBtn.hidden = !navigator.share;
          openModal('WishlistShareModal');
          setTimeout(function () { input.select(); }, 150);
        }
      });

      var nameInput = looksRoot.querySelector('[data-look-name]');
      var saveName = function () {
        var name = nameInput.value.trim();
        if (!name) { renderLooks(); return; }
        if (currentLook && Store.getLook(currentLook)) Store.renameLook(currentLook, name);
        else { var l = Store.createLook(name); if (l) currentLook = l.id; }
      };
      nameInput.addEventListener('change', saveName);
      nameInput.addEventListener('keydown', function (evt) { if (evt.key === 'Enter') { evt.preventDefault(); nameInput.blur(); } });

      document.addEventListener('wishlist:change', function (evt) {
        var a = evt.detail && evt.detail.action;
        if (a === 'add' || a === 'sync') loadLookData(); else renderLooks();
        updateLookTabs();
      });

      if (/#looks/.test(window.location.hash) && Store.count()) setTab('looks');
    }

    /* ---- Start ---- */

    function setupShared() {
      if (els.heading) els.heading.textContent = sharedMeta ? listLabel(sharedMeta) : els.heading.getAttribute('data-shared-heading');
      if (sharedMeta && sharedMeta.type !== 'custom' && els.sharedIntro) els.sharedIntro.textContent = els.sharedIntro.getAttribute('data-wish-intro');
      if (els.login) els.login.hidden = true;
      // Ny delt visning: hero i stedet for almindelig header og banner
      root.classList.add('is-shared');
      if (els.shareHero) {
        if (els.head) els.head.hidden = true;
        els.shared.hidden = true;
        els.shareHero.hidden = false;
        var wish = isWishList();
        var eyebrow = els.shareHero.querySelector('[data-share-eyebrow]');
        var intro = els.shareHero.querySelector('[data-share-intro]');
        var kind = sharedMeta && sharedMeta.type === 'look' ? 'data-look' : (wish ? 'data-wish' : 'data-default');
        eyebrow.textContent = eyebrow.getAttribute(kind) || eyebrow.getAttribute('data-default');
        intro.textContent = intro.getAttribute(kind) || intro.getAttribute('data-default');
        els.shareHero.querySelector('[data-share-title]').textContent =
          sharedMeta ? listLabel(sharedMeta) : els.heading.getAttribute('data-shared-heading');
        els.shareHero.classList.toggle('is-wish', wish);
        if (els.shareSteps) els.shareSteps.hidden = !wish;
        if (els.shareCta) els.shareCta.hidden = false;
      } else {
        els.shared.hidden = false;
      }
      root.querySelectorAll('[data-mode="own"]').forEach(function (b) { b.hidden = true; });
      root.querySelectorAll('[data-mode="shared"]').forEach(function (b) { b.hidden = false; });
      if (shareInfo) {
        if (shareInfo.owner && els.shareHero) {
          var eb = els.shareHero.querySelector('[data-share-eyebrow]');
          eb.textContent = eb.textContent + ' · ' + str('shareFrom', { name: shareInfo.owner });
        }
        if (shareInfo.isOwner && els.shared) {
          els.shared.hidden = false;
          els.shared.classList.add('wl-owner-note');
          els.sharedIntro.textContent = str('shareOwnerView');
        }
      }
    }

    if (mode === 'shared' && delCode) {
      root.classList.add('is-shared');
      if (els.head) els.head.hidden = true;
      if (els.login) els.login.hidden = true;
      setLoadingState(true);
      loadSharedFromServer().then(function (data) {
        setLoadingState(false);
        if (!data) {
          if (els.shared) {
            els.shared.hidden = false;
            els.sharedIntro.textContent = str('shareGone');
          }
          if (els.head) els.head.hidden = false;
          if (els.heading) els.heading.textContent = els.heading.getAttribute('data-shared-heading');
          root.querySelectorAll('[data-mode="own"]').forEach(function (b) { b.hidden = true; });
          els.empty.hidden = true;
          return;
        }
        setupShared();
        render();
      });
    } else {
      if (mode === 'shared') setupShared();
      render();
    }

    return {
      handlesRemoval: function (handle) { return mode === 'own' && !!cards[handle]; },
      removeWithUndo: removeWithUndo
    };
  })();

  /* ------------------------------------------------------------------ */
  /* Start                                                               */
  /* ------------------------------------------------------------------ */

  enhanceJsCards();
  syncButtons();
  syncHeader();

  // Lille offentligt API til evt. andre integrationer
  window.DFSWishlist = {
    items: Store.items,
    has: Store.has,
    add: function (handle, variant) { Store.add({ handle: handle, variant: variant, added: Date.now() }); },
    remove: Store.remove,
    clear: Store.clear,
    count: Store.count
  };
})();
